import type { TranslationKey } from './en.js';

import { interfaceRo } from './interface.js';
import { duesAttendanceRo } from './dues-attendance.js';

export const ro = {
  ...interfaceRo,
  ...duesAttendanceRo,
  'app.name': 'Managementul echipei sportive',
  'app.tagline': 'Activitatea clubului într-un singur loc sigur',
  'locale.label': 'Limba',
  'locale.en': 'Engleză',
  'locale.hu': 'Maghiară',
  'locale.ro': 'Română',
  'nav.overview': 'Prezentare generală',
  'nav.athletes': 'Sportivi',
  'nav.teams': 'Echipe',
  'nav.calendar': 'Calendar',
  'nav.training': 'Antrenamente',
  'nav.assessments': 'Evaluări',
  'nav.billing': 'Finanțe',
  'nav.payments': 'Plăți',
  'nav.competitions': 'Competiții',
  'nav.reports': 'Rapoarte',
  'nav.settings': 'Setări',
  'page.login': 'Autentificare',
  'page.invite': 'Acceptarea invitației',
  'page.notFound': 'Pagina nu a fost găsită',
  'help.login':
    'Alegeți Autentificare pentru a continua cu contul clubului; apoi reveniți aici. O sesiune se încheie după 30 de minute de inactivitate pentru conturile de personal și după 12 ore pentru conturile de familie, dar durează cel mult șapte zile. Dacă autentificarea eșuează, încercați din nou sau contactați secretarul clubului. Până la configurarea rolului dvs., nu sunt afișate date ale clubului.',
  'help.invite':
    'Deschideți linkul invitației primite de la club (de exemplu prin e-mail) sau lipiți aici codul invitației și autentificați-vă pentru a o accepta. O invitație este valabilă 72 de ore, poate fi folosită o singură dată și vă dă doar rolurile și persoanele sau conturile pe care le numește. Adresa de email singură nu oferă niciodată acces la datele unui copil. Aveți deja un cont, de exemplu dintr-o invitație anterioară sau de la alt club? Alegeți Autentificați-vă pentru a accepta. Nu aveți încă un cont? Alegeți Creați un cont. Dacă pagina de autentificare spune că adresa de e-mail este deja folosită, aveți deja un cont: autentificați-vă, folosind la nevoie linkul pentru parolă uitată. După autentificare sau înregistrare reveniți aici cu invitația completată; alegeți Acceptă invitația. Dacă ați fost invitat ca părinte fără un copil asociat, la început nu vedeți niciun copil: deschideți Copiii mei, folosiți Adăugare copil, iar copilul apare după aprobarea clubului.',
  'help.notFound':
    'Această pagină nu există sau nu ai acces la ea. Folosește meniul pentru a reveni la o zonă pe care o poți deschide.',
  'help.overview':
    'Prezentarea generală va rezuma ce necesită atenția ta. Arată doar zonele pe care ai voie să le folosești. Administratorii clubului și secretarii văd și ce necesită atenție: minori fără legătură de tutore, legături de tutori și importuri care așteaptă o decizie, membrii noi din ultimele 30 de zile și sportivii activi fără o perioadă de membru curentă, fiecare cu numărul și primele nume.',
  'help.athletes':
    'Sportivii sunt listați în ordine alfabetică, într-un tabel; folosește câmpul de căutare pentru a găsi pe cineva după nume. Fiecare rând se termină cu pictograme de acțiune: ochiul deschide detaliile sportivului (perioadele de membru al clubului, profilul de hochei și, pentru un tutore, cererile de modificare), iar administratorii clubului și secretarii au și creionul pentru corectarea datelor și cutia pentru arhivarea, retragerea sau reactivarea sportivului. Utilizatorii de la finanțe au și pictograma cu monedă și butonul Înregistrează plata în detalii: acesta deschide contul de facturare în care se află sportivul (alege unul dacă sunt mai multe) și înregistrează acolo o plată, de exemplu numerarul adus de sportiv, cu aceeași previzualizare și alocare la cele mai vechi sume deschise ca în pagina de facturare; un sportiv care nu este în niciun cont de facturare trebuie mai întâi adăugat acolo într-un cont. Pe telefon coloanele data nașterii, e-mail și telefon sunt ascunse; deschide detaliile pentru a le vedea. Butonul Adăugare sportiv din partea de sus a paginii deschide formularul pentru o înregistrare nouă. Vezi doar sportivii acoperiți de rolul tău: un părinte își vede copiii asociați, un antrenor vede sportivii departamentului său, iar administratorii clubului și secretarii văd întregul club. Doar administratorii clubului și secretarii pot adăuga un sportiv sau corecta o fișă și doar ei văd e-mailul și telefonul. Dacă există deja un sportiv cu același nume și aceeași dată de naștere, primești un avertisment și trebuie să confirmi înainte să se creeze a doua fișă; fișele nu sunt niciodată îmbinate automat. Dacă altcineva a modificat fișa în timp ce o editai, reîncarcă pagina și încearcă din nou. Secretarii văd aici și o secțiune Legături cu tutorii: pot solicita o legătură între un tutore și un sportiv (alegând un tutore deja existent în club sau introducând unul nou, relația și ce poate face tutorele), apoi o pot aproba, respinge sau retrage. O legătură nu oferă niciun acces până nu este aprobată, nu poți aproba o legătură în care tu ești tutorele, iar retragerea unei legături îi retrage imediat copilul acelui tutore. Echipele și grupele de antrenament se gestionează în pagina Echipe. În detaliile unui sportiv, în funcție de rolul tău, vezi perioadele de membru al clubului; administratorii clubului și secretarii pot începe o perioadă (data de început este implicit azi) sau o pot încheia pe una deschisă, iar perioada încheiată rămâne în istoric. Perioadele unui sportiv nu se pot suprapune și sunt independente de repartizările pe echipe și grupe: încheierea nu scoate sportivul din echipă. Când un sportiv împlinește 18 ani, accesul tutorelui la acel sportiv se suspendă automat; lista „Sportivi care împlinesc 18 ani” arată cine urmează, vă permite să invitați sportivul să-și creeze propriul cont și să reînnoiți fiecare legătură după autorizarea sportivului. De asemenea, puteți modifica ce poate face un tutore sau data de încheiere a unei legături aprobate. Administratorii clubului și secretarii pot, de asemenea, arhiva un sportiv sau înregistra retragerea acestuia, cu un motiv: aceasta încheie de astăzi calitatea de membru și repartizările pe echipe și grupe, iar retragerea încheie și accesul tutorilor după ziua de azi; totul rămâne în istoric, iar reactivarea nu restabilește nimic. Administratorii clubului și secretarii văd și o secțiune de import: descărcați un șablon CSV (sportivi, legături de tutori sau perioade de membru), completați-l în UTF-8, alegeți numele sistemului sursă și sistemul de date folosit de fișier, apoi verificați fișierul. Fiecare rând este verificat și marcat ca gata, cu erori, care necesită o decizie sau deja importat; un fișier cu formule, o foaie de calcul sau mai mult de 1.000 de rânduri este refuzat. Un rând care se potrivește cu un sportiv existent după nume și data nașterii necesită o decizie explicită (creați un sportiv nou, legați-l de cel existent sau omiteți-l); înregistrările nu se îmbină niciodată automat. Nu se salvează nimic până nu importați rândurile gata, și doar dacă niciun rând nu are erori sau nu așteaptă o decizie. Importul se aplică dintr-o dată; dacă între timp datele clubului s-au schimbat, nu se importă nimic și verificați din nou fișierul. Importul repetat al aceluiași fișier nu creează dubluri, deoarece rândurile sunt recunoscute după sursă și ID extern. Rândurile de tutori creează doar legături în așteptare, fără acces, iar nimeni nu este invitat sau notificat. Fiecare sportiv are și un Profil de hochei cu pozițiile preferate (portar, fundaș, atacant) și mâna cu crosa; îl citește oricine vede sportivul, iar administratorii clubului și secretarii îl pot modifica. Poziția jucată într-un meci se înregistrează în lotul meciului, nu aici. Un tutore poate cere o modificare în detaliile fiecărui copil legat: e-mail sau telefon nou ori corectarea numelui sau a datei nașterii. Nimic nu se schimbă până când un secretar nu aprobă; secretarul vede alăturat valorile actuale și pe cele propuse, trebuie să dea un motiv pentru respingere și nu poate soluționa o cerere făcută de el însuși. Corectările de nume și dată a nașterii trebuie verificate cu un document. O cerere aflată încă în așteptare poate fi retrasă. Un tutore vede și perioadele de membru în club ale unui copil legat, dacă legătura permite vizualizarea calității de membru. De obicei, părinții se alătură prin invitație: administratorii clubului și secretarii folosesc Invitați un părinte (adresa de e-mail și numele); dacă clubul are o adresă de expeditor, aplicația trimite invitația prin e-mail, altfel trimit linkul afișat; părintele se autentifică și, la Adăugare copil, introduce numele, data nașterii și relația pentru fiecare copil. Cererea în sine nu oferă niciun acces. Secretarii o văd la Copii solicitați de părinți, împreună cu sportivii născuți în aceeași zi care au un nume comun; aleg sportivul potrivit sau creează o fișă nouă, păstrează sau elimină permisiunile și aprobă, ceea ce deschide imediat o legătură aprobată cu tutorele, ori o resping cu un motiv pe care îl vede și părintele. Părintele poate retrage o cerere aflată încă în așteptare. Pentru a lega dumneavoastră un tutore de mai mulți sportivi existenți, adăugați fiecare sportiv în formularul de legătură și bifați aprobarea imediată a legăturilor după ce ați verificat relația. O legătură al cărei tutore nu are încă un cont oferă butonul Invită în aplicație. Aprobarea legăturilor cu tutorii și a cererilor de copii este o sarcină de secretar; un administrator al clubului își poate adăuga singur rolul de Secretar în Setări.',
  'help.teams':
    'Alege un sezon pentru a vedea echipele și grupele lui de antrenament, apoi deschide Arată membrii pentru a vedea cine face parte dintr-un lot. Vezi doar departamentele acoperite de rolul tău. Administratorii clubului și secretarii pot adăuga un sezon (începe ca ciornă; activează-l când începe și închide-l când se termină), pot adăuga echipe și grupe de antrenament la un sezon neînchis și pot repartiza sportivi sau încheia repartizarea lor. O repartizare are nevoie de o dată de început (implicit azi); încheierea unei repartizări o păstrează ca istoric, iar o dată de sfârșit viitoare ține sportivul în lot până în acea zi. Un sportiv nu poate fi în aceeași echipă sau grupă de două ori în perioade care se suprapun, iar un număr de tricou poate fi folosit de un singur membru al unei echipe la un moment dat. Categoriile de vârstă sunt doar etichete: ele nu decid cine este eligibil pentru o competiție. Dacă altcineva a modificat un sezon sau o repartizare în timp ce editai, reîncarcă pagina și încearcă din nou. Pentru pregătirea sezonului următor folosiți „Planificați sezonul următor”: alegeți ce echipe și grupe de antrenament păstrați (le puteți redenumi sau le puteți schimba categoria de vârstă), stabiliți datele și, dacă doriți, repartizați în noile echipe sportivii activi astăzi. Aceasta adaugă doar un sezon nou, în stadiul de ciornă; sezonul vechi, echipele și loturile lui nu se modifică niciodată.',
  'help.calendar':
    'Calendarul afișează evenimentele pe zile, pentru perioada aleasă. Personalul vede evenimentele departamentelor acoperite de rolul său; familiile văd doar evenimentele publicate ale propriilor copii asociați contului lor, cu ora, locul și termenul de răspuns. Administratorii clubului, secretarii și antrenorii pot adăuga un eveniment (mai întâi ca ciornă), pot invita echipe sau grupe de antrenament întregi ori pot deschide o listă cu Alege jucători și bifa doar jucătorii necesari, din oricâte echipe (oricine altcineva poate fi adăugat după nume), pot alege un patinoar, o zonă sau o sală și îl pot repeta în zilele alese în fiecare săptămână sau la fiecare două, trei sau patru săptămâni; un eveniment recurent își păstrează ora locală de început și la trecerea între ora de vară și cea de iarnă. Publicarea adaugă o singură dată sportivii invitați, chiar dacă fac parte din mai multe echipe sau grupe, și anunță familiile lor; anularea păstrează evenimentul împreună cu motivul, iar un eveniment anulat care nu a început poate fi readus cu Restabilește evenimentul. Deschideți orice sesiune a unei serii pentru a vedea sesiunile următoare: debifați una pentru a anula doar acea sesiune (de exemplu antrenamentul de mâine) și bifați-o din nou pentru a o readuce. Schimbă programul stabilește zile noi, o altă frecvență, oră sau dată de sfârșit dintr-o zi aleasă: sesiunile din zilele care rămân își păstrează răspunsurile și prezența și trec la noua oră, sesiunile din zilele eliminate sunt anulate cu motivul indicat de dvs., zilele noi se adaugă, iar sesiunile anterioare nu se schimbă. La anulare sau restabilire puteți alege dacă familiile invitate sunt anunțate; anunțurile sunt puse acum în coadă și se trimit după activarea notificărilor. Dacă schimbați cine este invitat la un eveniment publicat (Editează), participanții se actualizează imediat; cine a răspuns deja sau are prezența înregistrată își păstrează locul. Două evenimente nu pot folosi aceeași resursă în același timp (rezervarea întregului patinoar blochează zonele sale, iar timpul de curățare contează); un antrenor deja rezervat în altă parte este refuzat, iar sportivii deja așteptați la un alt eveniment necesită confirmarea dvs. Familiile răspund da, nu sau poate până la termen (implicit cu două ore înainte de început, dacă evenimentul nu prevede altfel); un antrenor poate corecta ulterior un răspuns, cu motiv. Deschideți un eveniment pentru a vedea cine a răspuns, iar antrenorii pot înregistra prezența cu o atingere pe sportiv: dacă un alt antrenor a salvat înaintea dvs. un rând, vedeți înregistrarea lui și nimic nu este suprascris. Dacă apartenențele se schimbă după publicare, verificați mai întâi modificările de apartenență; cine a răspuns sau are prezență înregistrată nu este niciodată eliminat. Patinoarele, zonele și sălile se configurează la Locații și resurse. Rata de prezență este suma prezenților și a întârziaților împărțită la suma prezenților, a întârziaților și a ambelor tipuri de absențe; evenimentele anulate și rândurile neînregistrate nu se numără.',
  'help.training':
    'Exercițiile și planurile de antrenament sunt pregătite aici de antrenori, pe departamente. Un exercițiu are un titlu în una sau mai multe limbi, o durată, echipament și instrucțiuni pentru antrenor pe care le vede doar personalul; salvarea unei modificări creează o versiune nouă și nu schimbă niciodată planurile care o folosesc deja pe una mai veche. Un plan este o listă de blocuri, fiecare cu un obiectiv, o durată, un exercițiu opțional, intensitate, echipament, suprafață și notițe private ale antrenorului; un bloc poate avea stații paralele și atunci durează cât cea mai lungă stație, nu suma lor. Timpul activ planificat trebuie să încapă în sesiune după pregătire și pauze, altfel trebuie indicat un motiv. Un plan începe ca ciornă; publicarea îngheață versiunea, iar pentru modificare se începe o versiune nouă, astfel încât o sesiune care a folosit-o deja păstrează exact ce a folosit. Alegeți ce blocuri primesc un scurt rezumat pentru familii: ciornele, obiectivele și notițele antrenorului nu le sunt niciodată afișate. Atașați o versiune publicată a planului unui eveniment în pagina Calendar.',
  'help.assessments':
    'Aici antrenorii definesc protocoale de evaluare. Un protocol stabilește tipul rezultatului (număr, durată, da sau nu, ori o grilă de niveluri), unitatea de măsură, câte zecimale se păstrează, cea mai mică și cea mai mare valoare validă, dacă mai mic sau mai mare este mai bine, câte încercări sunt permise și cum contează rezultatul: cea mai bună încercare, media, ultima încercare validă sau o încercare aleasă de antrenor, cu un motiv. Salvarea unei modificări creează o versiune nouă și nu schimbă niciodată sesiunile care au folosit o versiune mai veche; distanța, traseul, suprafața și metoda se păstrează cu fiecare rezultat, iar schimbarea oricăreia începe o serie nouă în graficele de progres. Pentru a înregistra rezultate, creați o sesiune pentru un departament, alegeți protocoalele și participanții, apoi introduceți fiecare încercare: lăsați goală o încercare care nu a fost făcută, introduceți zero doar pentru un zero măsurat și marcați o încercare greșită ca invalidă. Valorile imposibile, precum o durată negativă, prea multe zecimale, o valoare în afara limitelor sau o altă unitate de măsură, sunt refuzate cu un motiv. Rezultatele rămân ciorne, vizibile doar antrenorilor departamentului împreună cu notele lor private, până când le publicați; publicarea arată rezultatul care contează și comentariul pentru familii tutorilor a căror legătură o permite și sportivului. Dacă un alt antrenor a modificat mai întâi un rând, vedeți intrarea lui și nimic nu este suprascris. Un rezultat publicat se schimbă doar printr-o corectură cu motiv: familiile continuă să vadă rezultatul publicat până la publicarea corecturii, iar versiunea anterioară rămâne în evidență; o corectură nepublicată poate fi anulată, iar rezultatul publicat rămâne neschimbat. Exportă rezultatele descarcă rezultatele publicate ale unei sesiuni ca fișier CSV în limba dumneavoastră, fără ciorne, încercări sau notițe private; fiecare descărcare este înregistrată în jurnalul de audit. Sintezele de grup sunt doar pentru personal, nu se afișează pentru mai puțin de cinci participanți și nu există clasamente. La Progres, alegeți un sportiv pentru a vedea rezultatele publicate în timp, câte un grafic și un tabel pentru fiecare protocol comparabil; o întrerupere a liniei înseamnă că nu s-a înregistrat nicio valoare validă și nu este citită niciodată ca zero. Schimbarea afișată este un calcul despre măsurători, nu o apreciere a valorii sau a potențialului unui copil. La crearea unei sesiuni puteți adăuga dintr-o dată o echipă sau un grup de antrenament întreg al departamentului, apoi ajustați selecția după nume.',
  'help.billing':
    'Responsabilul financiar gestionează aici conturile de facturare. Secțiunea Conturi de facturare se deschide odată cu pagina și poate fi restrânsă; arată câte un cont pe rând, cu soldul, suma restantă, taxele viitoare și creditul nealocat (pe telefon doar soldul), iar Deschide contul îl afișează. În cont, cotizația anuală și planurile de taxă lunară sunt secțiuni separate: un club care percepe doar o cotizație anuală nu are nevoie de un plan de taxă lunară. Un plan de taxă nou pornește în moneda clubului, setată pe pagina Setări, la Datele clubului. Fiecare cont are propriul sold; soldurile conturilor diferite nu se adună niciodată. Înregistrați o taxă cu scadență sau o plată: previzualizați alocarea începând cu cea mai veche scadență, modificați sumele dacă este nevoie, apoi confirmați. Ce nu este alocat rămâne credit nealocat. Înregistrările nu se modifică: pentru corectare, stornați-le sau înregistrați cu motiv o notă de credit ori o rambursare. Reîncercarea după o pierdere a conexiunii nu înregistrează niciodată de două ori. Planurile de taxe stabilesc o sumă lunară, o zi a scadenței și datele în care se aplică; o versiune de plan nu se modifică niciodată, o schimbare se salvează ca versiune nouă. Pe un cont, alocați unui sportiv un plan de taxe de la o dată de început, eventual cu o reducere aprobată (sumă fixă sau procent, întotdeauna cu motiv), și suspendați-l sau încheiați-l când este nevoie; un sportiv are o singură taxă pe un cont la un moment dat, deci schimbarea planului înseamnă o încheiere și o alocare nouă. Pentru rularea lunară a taxelor, alegeți o lună, previzualizați ce se va înregistra, apoi înregistrați. Rularea înregistrează o taxă pe alocare și pe lună la data scadenței (o zi de după sfârșitul lunii cade în ultima zi a lunii); o alocare care începe la mijlocul lunii așteaptă să introduceți prima taxă; alocările suspendate sau încheiate sunt omise; iar o lună deja facturată nu se mai facturează niciodată, nici dacă rularea este înregistrată de două ori. La Rularea lunară automată, responsabilul financiar poate activa înregistrarea automată. Este dezactivată până o activați; după activare, sistemul verifică periodic și înregistrează taxele lunii curente după calendarul propriu al clubului, exact rândurile pe care previzualizarea le arată ca „Se vor înregistra”. Alocările care încep la mijlocul lunii așteaptă în continuare suma introdusă de dumneavoastră, o lună deja facturată nu se mai facturează niciodată, iar ultima rulare automată (reușită sau eșuată) apare sub comutator. O puteți dezactiva oricând; taxele deja înregistrate rămân. Pe un cont, Extrasul arată fiecare taxă, notă de credit, plată, storno și rambursare cu un sold curent. Alegeți o zi pentru a vedea contul așa cum era la sfârșitul acelei zile, cu restanța, taxele scadente în curând și creditul din ziua respectivă; înregistrările contează din momentul în care au fost făcute, așa că un extras mai vechi poate fi mereu reprodus. Descarcă CSV salvează extrasul zilei alese, cu contul și ziua în partea de sus a fișierului; fiecare descărcare este înregistrată în jurnalul de audit. La Persoane cu acces puteți aproba o persoană pentru acest cont, cu o permisiune și date, sau puteți revoca o aprobare; aprobările sunt pe cont și independente de orice legătură de tutore, iar o aprobare revocată ascunde contul imediat. Pentru o plată cu credit încă disponibil, Alocă creditul propune alocarea acestui credit începând cu cea mai veche scadență, pe care o puteți ajusta și confirma. La Rapoarte alegeți o zi și vedeți taxele și plățile întregului club așa cum arăta registrul la sfârșitul acelei zile, câte un bloc pe monedă, fără a le aduna. Puteți filtra după sezon, după echipa în care se afla sportivul la data scadenței taxei, după metoda de plată sau după cont (filtrul de echipă lasă plățile deoparte, iar cel de metodă lasă taxele deoparte, pentru că taxele nu au metodă, iar plățile nu au echipă). Reconcilierea compară vederile de taxe, plăți, alocări, rambursări și extras ale aceluiași registru și marchează orice diferență. Descărcarea CSV salvează aceleași cifre, cu ziua și filtrele în partea de sus; fiecare descărcare este înregistrată în jurnalul de audit. La Perioade închise, finanțele pot bloca registrul până la o zi din trecut: după aceea nu se mai poate înregistra, nici manual, nici prin generarea taxelor, o taxă cu scadența sau o plată din ziua respectivă ori dinaintea ei (generarea marchează aceste alocări ca omise, deoarece perioada de raportare este închisă). Închiderea este definitivă și merge mereu înainte; pentru a corecta ceva dintr-o perioadă închisă, înregistrați o notă de credit, o stornare sau o rambursare, care primește data perioadei deschise. La Import verificați un fișier CSV cu conturi de facturare, sportivi asociați conturilor, solduri de deschidere sau plăți (descărcați mai întâi șablonul; conturile și sportivii sunt indicați prin ID-urile externe din aceeași sursă, iar sportivii trebuie importați înainte). Verificarea listează fiecare problemă pe rând și arată totalurile rândurilor valide, pentru a le compara cu tabelul sursă. Importul înregistrează doar intrări noi, într-un singur pas: un sold de deschidere devine o taxă sau un credit de deschidere, o plată importată rămâne credit nealocat, intrările dintr-o perioadă închisă sunt refuzate, iar importul aceluiași fișier încă o dată nu schimbă nimic. La Cotizații anuale pe echipe, alegeți un an și stabiliți cotizația anuală a fiecărei grupe de vârstă (de exemplu U7–U9 și U11 1000 RON, U13 și peste 1300 RON); o modificare înlocuiește cotizația acelui an și este înregistrată în jurnalul de audit. Lista de dedesubt arată fiecare cont cu sportivii săi și echipa lor, cotizația anuală, cât s-a achitat în acel an și cât a rămas de achitat (sau cât s-a achitat în plus). Echipa este cea în care se află sportivul la începutul anului sau prima în care a intrat în cursul anului. Se iau în calcul toate plățile datate în acel an, fără rambursări, chiar dacă nu sunt alocate unei sume datorate; un cont al cărui sportiv nu are echipă sau nu are cotizație pentru grupa sa de vârstă este marcat ca incomplet. Filtrați după echipă sau afișați doar conturile cu sumă rămasă. Lista nu înregistrează nimic; pentru a factura cotizația ca sume datorate, folosiți Cotizație anuală pe cont.',
  'help.payments':
    'Pagina Plăți arată conturile de facturare pe care clubul v-a aprobat să le vedeți. Fiecare cont are propriul sold, propria restanță, sumele scadente în curând și creditul nealocat; soldurile conturilor diferite nu se adună niciodată. Cu Afișează extrasul de cont vedeți toate taxele, plățile și rambursările unui cont, cu soldul curent, și puteți alege o zi pentru a vedea contul așa cum arăta la sfârșitul acelei zile. Legătura cu un copil nu arată contul copilului: echipa financiară a clubului aprobă fiecare persoană pentru fiecare cont, iar retragerea aprobării ascunde contul imediat. Această pagină doar informează; plățile sunt înregistrate de club. Dacă o sumă pare greșită, contactați echipa financiară a clubului.',
  'help.competitions':
    'Un sezon de competiție leagă sezonul unui departament de o competiție (federație, categorie, divizie și faze); îl creează responsabilii competițiilor (administratorii clubului, secretarii și antrenorii). Fiecare competiție își listează versiunile profilului de reguli. Un administrator al clubului pornește o schiță din catalogul livrat FRHG 2026–2027, înregistrează SHA-256 pentru fiecare document sursă citit și ziua în care sursele au fost verificate pentru modificări, apoi activează versiunea; activarea înlocuiește versiunea care era activă, iar o versiune activată nu se mai schimbă niciodată. O schiță, o versiune înlocuită sau lipsa oricărui profil nu aprobă niciodată pe nimeni: eligibilitatea rămâne „necesită verificare”. O schiță fără nicio sursă nu poate fi activată, iar verificările manuale obligatorii listate pe profil rămân deschise. La Înregistrări, responsabilul competițiilor înscrie un sportiv în competiție printr-o echipă din același departament și sezon, alegând modul de înregistrare (nativ, promovare temporară sau exclusiv categoria superioară), prima zi, o ultimă zi opțională și o referință de licență opțională. Un sportiv poate avea o singură înregistrare activă pe competiție într-o zi, dar poate fi înregistrat în mai multe competiții simultan. Corectare schimbă ultima zi sau referința de licență; Încheie înregistrarea notează ultima zi (nu în viitor) și un motiv și păstrează înregistrarea ca istoric, așa că o nouă înregistrare creează o înregistrare nouă. O înregistrare nu schimbă calitatea de membru al clubului și nici loturile, iar înregistrarea o văd doar cei care pot vedea sportivul. La Documente justificative, responsabilul competițiilor notează că există un document (aviz medical, un acord, o aprobare de împrumut sau de transfer) pentru un sportiv, cine l-a emis și zilele în care este valabil. O înregistrare nouă așteaptă decizia: Aprobă confirmă că ai văzut documentul, iar Respinge păstrează înregistrarea ca istoric, cu un motiv. O înregistrare care așteaptă poate fi corectată; una aprobată nu mai poate fi corectată, doar retrasă cu un motiv, iar un document de înlocuire este o înregistrare nouă. Doar dovezile aprobate contează pentru eligibilitate; o înregistrare care așteaptă sau este respinsă nu contează niciodată. Copia documentului nu este păstrată, deci nu scrie detalii medicale în note sau motive. La Suspendări, un registrator înregistrează că un sportiv nu are voie să joace – până la o ultimă zi sau pentru un număr de meciuri –, în această competiție sau în toate competițiile clubului, cu o referință opțională a deciziei. Cât timp o suspendare este activă, ea poate fi corectată (prima zi, ultima zi sau numărul de meciuri și referința; o suspendare numărată în zile rămâne în zile, iar una numărată în meciuri rămâne în meciuri), marcată ca executată sau revocată cu un motiv. O suspendare executată sau revocată rămâne ca istoric și nu se mai schimbă niciodată. Doar o suspendare activă contează pentru eligibilitate. La Meciuri, un registrator atașează un meci competiției: alege un eveniment de tip meci al departamentului pe care nu îl folosește încă alt meci (se creează mai întâi în Calendar), echipa clubului, faza, o denumire a adversarului și gazdă sau oaspete. Cât timp meciul este programat, poate fi corectat (faza, adversarul, gazdă sau oaspete), încheiat după ce a venit ziua lui sau anulat cu un motiv; un meci anulat eliberează evenimentul. Încheierea înregistrează ce versiune a regulilor era activă în acel moment, iar meciul o păstrează chiar dacă mai târziu se activează o versiune mai nouă. Un meci încheiat sau anulat rămâne ca istoric și nu se mai schimbă niciodată. La Lot, un registrator selectează sportivii unui meci programat: caută sportivul, alege rolul în acest meci (portar, fundaș sau atacant) și, opțional, un număr de tricou între 0 și 99 pe care niciun alt sportiv din lot nu îl poartă, apoi modifică sau elimină intrările după nevoie. Fiecare modificare se salvează imediat. Un lot se poate modifica doar cât timp meciul este programat; după ce meciul este încheiat sau anulat, lotul rămâne așa cum a fost. Selecția nu verifică eligibilitatea și nu dovedește că sportivul a jucat. La Eligibilitate, în lot, un registrator verifică lotul afișat după versiunea de reguli activă a competiției: fiecare sportiv și lotul în ansamblu primesc Eligibil, Neeligibil sau Necesită verificare, cu fiecare motiv și clauza sursă, iar rezultatul se salvează cu ziua și versiunea de reguli folosite. Fără o versiune de reguli activă nimeni nu este eligibil. Meciurile jucate în afara clubului se iau în calcul doar după ce sunt înregistrate la Meciuri în afara clubului și un registrator a atestat că istoricul este complet; până atunci, oriunde regulile limitează meciurile pe zi sau pe săptămână, cel mai bun rezultat este Necesită verificare. Celelalte meciuri ale sportivului în club se socotesc și ele în aceste limite. Când se schimbă o înregistrare, o dovadă, o suspendare, lotul sau versiunea de reguli activă, rezultatul salvat apare ca depășit și rămâne în istoric până verifici din nou. Verificarea acoperă doar regulile automatizate; verificările manuale enumerate sub ea rămân în sarcina ta. O înregistrare consemnează și clasificarea în competiție (general, fete sau jucătoare de lot național) folosită de reguli; se poate corecta cât timp înregistrarea este activă și doar registratorii o văd. Finalizarea lotului îngheață lotul unui meci programat: fiecare sportiv este verificat din nou după versiunea de reguli activă a competiției și după celelalte loturi finalizate ale sportivului, iar finalizarea este refuzată dacă un sportiv nu este eligibil sau lotul încalcă o regulă. Acolo unde ceva mai necesită verificare (de exemplu pentru că meciurile jucate în afara clubului nu sunt înregistrate), trebuie să declari în cuvinte că ai verificat. Un lot finalizat nu mai poate fi modificat sau verificat din nou până nu îl redeschizi cu un motiv; verificarea salvată pe baza căreia a fost finalizat rămâne ca istoric. La finalizarea altui lot, pentru limitele zilnice și săptămânale contează ca apariții doar loturile finalizate, deci dacă două loturi numesc același sportiv în aceeași zi, rămâne valabil cel finalizat primul, iar al doilea este refuzat. Exportă lotul (CSV) descarcă lotul afișat ca fișier de uz intern, cu numărul de tricou, numele, rolul și rezultatul unei verificări proaspete; este întotdeauna marcat ca instrument intern și nu este niciodată o depunere la federație. Fișierul spune dacă este gata oficial, ceea ce cere o versiune de reguli activă, un lot finalizat și listat integral, nicio problemă la sportivi sau la lot și fiecare verificare manuală obligatorie înregistrată ca făcută; altfel este o ciornă și sunt listate motivele. La Eligibilitate, fiecare verificare manuală obligatorie a versiunii active de reguli poate fi înregistrată ca făcută: scrie ce ai verificat și în ce zi, iar dacă a fost înregistrată greșit folosește Retrage înregistrarea, cu un motiv. O înregistrare este valabilă doar pentru lotul așa cum este acum și pentru versiunea de reguli activă acum, deci modificarea unei intrări sau activarea altor reguli redeschide verificarea; se poate înregistra cât timp meciul nu este anulat, și după finalizarea lotului. La Meciuri în afara clubului, un registrator caută un sportiv și înregistrează fiecare meci verificat jucat în afara loturilor clubului (ziua, competiția sau clubul și unde a fost verificat), apoi atestă că toate meciurile de acest fel dintr-o zi până într-alta (nu în viitor) sunt înregistrate. O atestare contează la verificarea unui lot doar dacă începe cel târziu în prima zi a celei mai lungi ferestre săptămânale a regulilor și se termină cel devreme în ziua dinaintea meciului, deci reînnoiește-o cu puțin timp înainte de meci; un meci jucat chiar în ziua meciului contează doar dacă este înregistrat. O înregistrare sau o atestare se retrage cu un motiv; ce a fost înregistrat nu se schimbă niciodată, cea retrasă rămâne ca istoric, iar o corectură înseamnă o retragere plus o înregistrare nouă. Nu scrie date personale în sursă sau în declarație. Fiecare export este scris în jurnalul de audit.',
  'help.reports':
    'Rapoartele și exporturile vor fi disponibile aici, limitate la datele pe care rolul tău are voie să le vadă.',
  'help.settings':
    'Administratorii clubului setează datele clubului la Datele clubului: numele clubului (afișat în antetul paginii și ca expeditor al e-mailurilor), limba e-mailurilor clubului, fusul orar care stabilește zilele calendaristice și scadențele, precum și moneda. Moneda se folosește pentru conturile de facturare, planurile de taxe și cotizațiile anuale noi; conturile existente își păstrează moneda în care au fost deschise. Administratorii clubului pot adăuga un rol de personal altui membru sau pot retrage un rol; un rol retras încetează la următoarea acțiune a membrului, iar clubul păstrează mereu cel puțin un administrator. Un membru poate fi și suspendat: este deconectat imediat din acest club și nu poate folosi niciun rol până la reactivare, iar rolurile sale se păstrează. Pentru a șterge un membru din club, folosiți Elimină din club și confirmați: toate rolurile sale sunt retrase, este deconectat din acest club și dispare din listă, iar prezențele, plățile și restul istoricului se păstrează. Un membru eliminat poate reveni doar acceptând o nouă invitație; contul său de autentificare și celelalte cluburi nu sunt afectate. Alegerea limbii modifică doar etichetele. Administratorii clubului pot invita prin e-mail și un nou membru de personal: bifați unul sau mai multe roluri (de exemplu Administrator de club, Antrenor și Secretar) și creați invitația; la acceptare, persoana primește toate rolurile bifate. Aplicația trimite invitația prin e-mail de la adresa de expeditor a clubului, în limba clubului; linkul este valabil 72 de ore, poate fi folosit o singură dată și poate fi retras cât timp așteaptă. Pentru a curăța lista de invitații, bifați invitațiile încheiate (acceptate, retrase sau expirate) una câte una sau folosiți Selectați toate invitațiile încheiate, apoi Ștergeți selecția și confirmați; invitațiile în așteptare nu pot fi șterse până nu le retrageți, iar jurnalul de audit păstrează în continuare fiecare invitație. Linkul apare și o singură dată, cu Copiază linkul, ca să îl puteți trimite dumneavoastră dacă e-mailul nu a putut fi trimis. Adresa de expeditor se setează la Expeditor e-mail: invitațiile vin de la această adresă, cu numele clubului ca expeditor, iar serverul de e-mail al clubului trebuie să aibă dreptul să trimită pentru domeniul ei. Fără adresă de expeditor nu se trimite niciun e-mail. Administratorii clubului pot stabili și cât timp poate rămâne inactivă o sesiune de personal sau de familie și câte zile poate dura o sesiune; noile limite se aplică sesiunilor începute după salvare. Administratorii clubului pot încărca și sigla clubului (PNG, JPEG sau WebP); toți membrii clubului o văd în antetul paginii și o pot înlocui sau elimina oricând. Folosește Modifică data de încheiere lângă un rol pentru a modifica sau elimina data; salvarea deconectează membrul din acest club. Nu poți modifica data de încheiere a propriului rol sau a unui rol retras. Rolul de administrator poate avea o dată de încheiere doar dacă un alt administrator activ al clubului are un rol fără dată de încheiere. Un administrator al întregului club poate adăuga explicit propriului cont rolurile Antrenor, Financiar sau Secretar, astfel încât o singură persoană să poată conduce un club mic. Fiecare adăugare este auditată și necesită o nouă autentificare; rolul Antrenor permite înregistrarea prezenței, iar rolul Financiar permite înregistrarea plăților cotizațiilor. Membrii sunt afișați cu numele și adresa de e-mail furnizate la autentificare; un membru care nu s-a mai autentificat de atunci apare cu adresa din invitație sau este marcat ca încă necunoscut. Părinții se invită din pagina Sportivi, la Invitați un părinte.',
  'sessionPolicy.title': 'Limitele sesiunii de autentificare',
  'sessionPolicy.note':
    'Personalul este deconectat după minutele de inactivitate de mai jos, iar conturile de familie după minutele de inactivitate pentru familii; orice sesiune se încheie și după numărul maxim de zile. Modificările se aplică sesiunilor începute după salvare.',
  'sessionPolicy.loading': 'Se încarcă limitele sesiunii…',
  'sessionPolicy.staffIdle': 'Limită de inactivitate pentru personal (minute)',
  'sessionPolicy.familyIdle': 'Limită de inactivitate pentru familii (minute)',
  'sessionPolicy.absolute': 'Durata maximă a sesiunii (zile)',
  'sessionPolicy.save': 'Salvează limitele sesiunii',
  'sessionPolicy.saved': 'Limitele sesiunii au fost salvate.',
  'mailSettings.title': 'Expeditor e-mail',
  'mailSettings.note':
    'E-mailurile cu invitații sunt trimise de la această adresă, cu numele clubului ca nume de expeditor. Folosiți o adresă dintr-un domeniu pentru care serverul de e-mail are dreptul să trimită, altfel destinatarii s-ar putea să nu primească e-mailurile. Lăsați câmpul gol pentru a opri trimiterea e-mailurilor.',
  'mailSettings.address': 'Adresa de e-mail a expeditorului',
  'mailSettings.save': 'Salvează adresa de expeditor',
  'mailSettings.saved': 'Adresa de expeditor a fost salvată.',
  'mailSettings.loading': 'Se încarcă setările de e-mail…',
  'mailSettings.unavailable':
    'Trimiterea e-mailurilor nu este încă configurată pe acest server, așa că nu se trimite niciun e-mail nici cu o adresă setată. Cereți operatorului să configureze serverul de e-mail.',
  'mailSettings.invalid': 'Introduceți o adresă de e-mail validă sau lăsați câmpul gol.',
  'clubData.title': 'Datele clubului',
  'clubData.note':
    'Numele clubului apare în antetul paginii și ca expeditor al e-mailurilor sale. Limba este folosită pentru e-mailurile trimise de club, fusul orar stabilește zilele calendaristice ale clubului (de exemplu, scadența taxei lunare), iar moneda este folosită pentru conturile de facturare, planurile de taxe și cotizațiile anuale noi.',
  'clubData.loading': 'Se încarcă datele clubului…',
  'clubData.saved': 'Datele clubului au fost salvate.',
  'clubData.name': 'Numele clubului',
  'clubData.nameRequired': 'Introduceți numele clubului.',
  'clubData.language': 'Limba clubului',
  'clubData.languageHelp': 'Folosită pentru invitații și celelalte e-mailuri ale clubului.',
  'clubData.timezone': 'Fus orar',
  'clubData.timezoneHelp': 'Zilele calendaristice și scadențele urmează acest fus orar.',
  'clubData.currency': 'Monedă',
  'clubData.currencyHelp':
    'Folosită pentru conturile, planurile de taxe și cotizațiile anuale noi. Conturile existente își păstrează moneda.',
  'clubData.save': 'Salvează datele clubului',
  'error.clubData.invalidTimeZone': 'Acesta nu este un fus orar cunoscut.',
  'billing.accounts.table.account': 'Cont',
  'billing.accounts.table.actions': 'Acțiuni',
  'billing.fees.assign.noPlansInCurrency':
    'Nu există niciun plan de taxă lunară în moneda acestui cont. Creați unul la Planuri de taxe și taxe lunare, pe pagina Finanțe.',
  'mail.invitation.subject': 'Invitație de la {club}',
  'mail.invitation.greeting': 'Bună ziua,',
  'mail.invitation.body':
    '{club} vă invită să vă alăturați în {app} cu următoarele roluri: {roles}.',
  'mail.invitation.action': 'Acceptă invitația',
  'mail.invitation.linkIntro': 'Linkul invitației:',
  'mail.invitation.expiry': 'Invitația poate fi folosită o singură dată și expiră la {expiresAt}.',
  'mail.invitation.accountExisting':
    'Aveți deja un cont cu această adresă de e-mail, de exemplu dintr-o invitație anterioară. Deschideți linkul și autentificați-vă cu el; nu vă înregistrați din nou. Dacă ați uitat parola, folosiți linkul pentru parolă uitată de pe pagina de autentificare.',
  'mail.invitation.accountNew':
    'Nu aveți încă un cont? Deschideți linkul și alegeți Creați un cont. Dacă pagina de autentificare spune că adresa de e-mail este deja folosită, aveți deja un cont: autentificați-vă, folosind la nevoie linkul pentru parolă uitată. Apoi reveniți la invitație pentru a o accepta.',
  'mail.invitation.ignore':
    'Dacă nu vă așteptați la această invitație, ignorați acest e-mail; fără link nu se schimbă nimic.',
  'logo.title': 'Sigla clubului',
  'logo.note':
    'Apare în antetul paginii pentru toți membrii clubului. PNG, JPEG sau WebP, cel mult {kilobytes} KB.',
  'logo.none': 'Încă nu există o siglă.',
  'logo.current': 'Sigla actuală a clubului',
  'logo.choose': 'Alege sigla',
  'logo.replace': 'Înlocuiește sigla',
  'logo.remove': 'Elimină sigla',
  'logo.uploaded': 'Sigla a fost salvată.',
  'logo.removed': 'Sigla a fost eliminată.',
  'logo.error.unsupportedType': 'Alegeți o imagine PNG, JPEG sau WebP.',
  'logo.error.tooLarge': 'Imaginea este prea mare. Alegeți una mai mică.',
  'roles.title': 'Roluri și acces',
  'roles.validity.edit': 'Modifică data de încheiere',
  'roles.validity.save': 'Salvează data de încheiere',
  'roles.validity.cancel': 'Anulează',
  'roles.validity.help':
    'Alege o dată viitoare de încheiere sau lasă câmpul gol pentru durată nelimitată. Datele folosesc fusul orar al dispozitivului. Salvarea deconectează membrul din acest club. Nu poți modifica data de încheiere a propriului rol sau a unui rol retras. Rolul de administrator poate avea o dată de încheiere doar dacă un alt administrator activ al clubului are un rol fără dată de încheiere.',
  'roles.loading': 'Se încarcă rolurile…',
  'roles.empty': 'Niciun membru nu deține încă un rol pe care îl puteți gestiona.',
  'roles.you': '(dumneavoastră)',
  'roles.department': 'Departament',
  'roles.scope.organization': 'Întregul club',
  'roles.status.active': 'Activ',
  'roles.status.revoked': 'Retras',
  'roles.status.expired': 'Încheiat',
  'roles.until': 'până la',
  'roles.revoke': 'Retrage',
  'roles.revoke.confirm': 'Confirmați retragerea',
  'roles.assign.bundle': 'Adăugați un rol de personal',
  'roles.assign.until': 'Se încheie la (opțional)',
  'roles.assign.submit': 'Adaugă rolul',
  'roles.assign.selfHelp':
    'Ca administrator al întregului club, poți adăuga propriului cont rolurile Antrenor, Financiar sau Secretar. Adaugă Antrenor pentru a înregistra prezența și Financiar pentru a înregistra plățile cotizațiilor. După fiecare adăugare, autentifică-te din nou pentru a folosi noul rol.',
  'roles.loadMore': 'Afișează mai mulți membri',
  'roles.member.unnamed':
    'Numele nu este încă cunoscut (apare după următoarea autentificare a membrului)',
  'roles.member.status.active': 'Activ',
  'roles.member.status.suspended': 'Suspendat',
  'roles.member.status.invited': 'Invitat',
  'roles.member.status.revoked': 'Eliminat',
  'roles.member.suspend': 'Suspendă membrul',
  'roles.member.suspend.confirm': 'Confirmați suspendarea',
  'roles.member.reactivate': 'Reactivează membrul',
  'roles.member.remove': 'Elimină din club',
  'roles.member.remove.confirm': 'Confirmați eliminarea',
  'roles.member.remove.warning':
    'Eliminarea retrage toate rolurile acestui membru, îl deconectează din acest club și îl scoate din această listă. Istoricul său se păstrează. Pentru a-l readuce, trimiteți-i o nouă invitație.',
  'roles.bundle.club_admin': 'Administrator de club',
  'roles.bundle.secretary': 'Secretar',
  'roles.bundle.finance': 'Financiar',
  'roles.bundle.coach': 'Antrenor',
  'roles.bundle.registrar': 'Responsabil cu evidența (desființat)',
  'roles.bundle.rules_officer': 'Responsabil cu regulamentele (desființat)',
  'roles.bundle.guardian': 'Tutore',
  'roles.bundle.athlete': 'Sportiv',
  'invitations.title': 'Invitații',
  'invitations.loading': 'Se încarcă invitațiile…',
  'invitations.empty': 'Încă nu există invitații.',
  'invitations.create.email': 'Adresa de e-mail a persoanei invitate',
  'invitations.create.submit': 'Creează invitația',
  'invitations.created':
    'Invitația a fost creată. Linkul de mai jos apare o singură dată și este valabil 72 de ore; fără cont, persoana se poate înregistra pe pagina de autentificare.',
  'invitations.link': 'Linkul invitației',
  'invitations.copy': 'Copiază linkul',
  'invitations.copied': 'Linkul a fost copiat',
  'invitations.copyFailed': 'Linkul nu a putut fi copiat; selectați-l și copiați-l manual.',
  'invitations.status.pending': 'În așteptare',
  'invitations.status.accepted': 'Acceptată',
  'invitations.status.revoked': 'Retrasă',
  'invitations.status.expired': 'Expirată',
  'invitations.expires': 'expiră',
  'invitations.revoke': 'Retrage invitația',
  'invitations.revoke.confirm': 'Confirmă retragerea',
  'invitations.loadMore': 'Afișează mai multe invitații',
  'invitations.create.bundles': 'Roluri oferite',
  'invitations.create.bundlesHint':
    'Bifați fiecare rol pe care trebuie să îl primească persoana; toate se acordă la acceptare.',
  'invitations.createdRoles': 'Rolurile din această invitație',
  'invitations.delivery.sent': 'Invitația a fost trimisă prin e-mail la {email}.',
  'invitations.delivery.no_sender':
    'Nu s-a trimis niciun e-mail, deoarece clubul nu are o adresă de expeditor. Setați una la Expeditor e-mail sau trimiteți dumneavoastră linkul de mai jos.',
  'invitations.delivery.unavailable':
    'Trimiterea e-mailurilor nu este configurată pe acest server, așa că nu s-a trimis niciun e-mail. Trimiteți dumneavoastră linkul de mai jos.',
  'invitations.delivery.failed':
    'E-mailul cu invitația nu a putut fi trimis. Trimiteți dumneavoastră linkul de mai jos sau retrageți invitația și încercați din nou mai târziu.',
  'invitations.emailed': 'E-mail trimis',
  'invitations.select': 'Selectați invitația trimisă la {email}',
  'invitations.selectAll': 'Selectați toate invitațiile încheiate',
  'invitations.delete': 'Ștergeți selecția ({count})',
  'invitations.delete.confirm': 'Confirmați ștergerea a {count}',
  'invitations.delete.cancel': 'Anulare',
  'invitations.delete.hint': 'Invitațiile în așteptare nu pot fi șterse; retrageți-le mai întâi.',
  'invitations.deleted': 'Invitații șterse: {count}.',
  'invitations.familyNote':
    'Părinții se invită din pagina Sportivi, la Invitați un părinte; sportivii care împlinesc 18 ani se invită din lista accesului tutorilor.',
  'athletes.loading': 'Se încarcă sportivii…',
  'athletes.empty': 'Nu există sportivi de afișat.',
  'athletes.search.label': 'Căutare după nume',
  'athletes.search.submit': 'Caută',
  'athletes.dateOfBirth': 'Data nașterii',
  'athletes.givenName': 'Prenume',
  'athletes.familyName': 'Nume de familie',
  'athletes.email': 'E-mail',
  'athletes.phone': 'Telefon',
  'athletes.status.active': 'Activ',
  'athletes.status.archived': 'Arhivat',
  'athletes.status.withdrawn': 'Retras',
  'athletes.create.title': 'Adăugare sportiv',
  'athletes.create.submit': 'Adaugă sportiv',
  'athletes.create.anyway': 'Este o altă persoană – adaugă oricum',
  'athletes.edit': 'Editează datele',
  'athletes.edit.save': 'Salvează modificările',
  'athletes.edit.cancel': 'Anulare',
  'athletes.loadMore': 'Arată mai mulți sportivi',
  'athletes.saved': 'Salvat.',
  'athletes.table.name': 'Nume',
  'athletes.table.status': 'Stare',
  'athletes.table.actions': 'Acțiuni',
  'athletes.action.details': 'Vezi detaliile',
  'athletes.action.status': 'Schimbă starea',
  'athletes.action.payment': 'Înregistrează plata',
  'athletes.payment.loading': 'Se încarcă conturile de facturare…',
  'athletes.payment.noAccount':
    'Acest sportiv nu este încă într-un cont de facturare. Adaugă-l mai întâi într-un cont în pagina Finanțe.',
  'athletes.payment.account': 'Cont de facturare',
  'athletes.payment.recorded': 'Plata a fost înregistrată.',
  'athletes.payment.openAccount': 'Deschide contul',
  'athletes.payment.goToBilling': 'Mergi la Finanțe',
  'athletes.dialog.close': 'Închide',
  'clubMembership.title': 'Calitatea de membru al clubului',
  'clubMembership.loading': 'Se încarcă calitatea de membru…',
  'clubMembership.empty': 'Nu este înregistrată nicio perioadă de membru.',
  'clubMembership.from': 'Membru din',
  'clubMembership.until': 'până la',
  'clubMembership.openEnded': 'fără dată de sfârșit',
  'clubMembership.joinedOn': 'Membru din (gol = azi)',
  'clubMembership.join': 'Începe calitatea de membru',
  'clubMembership.end': 'Încheie calitatea de membru',
  'clubMembership.end.confirm': 'Confirmă încheierea',
  'error.athlete.duplicateCandidate':
    'Există deja un sportiv cu acest nume și această dată de naștere. Dacă este o altă persoană, confirmă adăugarea.',
  'error.athlete.dateOfBirthInFuture': 'Data nașterii nu poate fi în viitor.',
  'guardianLinks.title': 'Legături cu tutorii',
  'guardianLinks.intro':
    'O legătură oferă unui tutore acces la un sportiv abia după ce o aprobi. Nu poți aproba o legătură în care tu ești tutorele.',
  'guardianLinks.loading': 'Se încarcă legăturile cu tutorii…',
  'guardianLinks.empty': 'Nu există legături cu tutorii de afișat.',
  'guardianLinks.filter.label': 'Afișare',
  'guardianLinks.filter.all': 'Toate',
  'guardianLinks.status.pending': 'În așteptarea aprobării',
  'guardianLinks.status.approved': 'Aprobată',
  'guardianLinks.status.rejected': 'Respinsă',
  'guardianLinks.status.revoked': 'Retrasă',
  'guardianLinks.athlete': 'Sportiv',
  'guardianLinks.guardian': 'Tutore',
  'guardianLinks.relationship': 'Relația',
  'guardianLinks.relationship.parent': 'Părinte',
  'guardianLinks.relationship.legal_guardian': 'Tutore legal',
  'guardianLinks.relationship.grandparent': 'Bunic / bunică',
  'guardianLinks.relationship.other': 'Altă relație',
  'guardianLinks.validFrom': 'Valabilă din',
  'guardianLinks.validUntil': 'Valabilă până la',
  'guardianLinks.openEnded': 'fără dată de încheiere',
  'guardianLinks.capabilities': 'Ce poate face tutorele',
  'guardianLinks.capability.viewSchedule': 'Poate vedea programul',
  'guardianLinks.capability.respondRsvp': 'Poate răspunde la cererile de participare',
  'guardianLinks.capability.viewPublishedResults': 'Poate vedea rezultatele publicate',
  'guardianLinks.capability.viewMembership': 'Poate vedea calitatea de membru',
  'guardianLinks.capability.receiveNotices': 'Poate primi notificări',
  'guardianLinks.approve': 'Aprobă',
  'guardianLinks.reject': 'Respinge',
  'guardianLinks.revoke': 'Retrage',
  'guardianLinks.revoke.confirm': 'Confirmă retragerea',
  'guardianLinks.loadMore': 'Afișează mai multe legături cu tutorii',
  'guardianLinks.saved': 'Salvat.',
  'guardianLinks.create.title': 'Solicitare legătură cu un tutore',
  'guardianLinks.create.submit': 'Solicită legătura',
  'guardianLinks.create.athleteSearch': 'Caută sportivul după nume',
  'guardianLinks.create.noMatches': 'Nicio potrivire',
  'guardianLinks.create.existingGuardian': 'Un tutore deja existent în club',
  'guardianLinks.create.newGuardian': 'Un tutore nou',
  'guardianLinks.create.guardianSearch': 'Caută tutorele după nume',
  'guardianLinks.create.guardianSource': 'Tutore',
  'childRequests.title': 'Adăugare copil',
  'childRequests.hint':
    'Introduceți numele și data nașterii copilului așa cum le cunoaște clubul. Un secretar verifică cererea și asociază copilul cu contul dumneavoastră; până atunci nu vedeți nimic despre copil.',
  'childRequests.note': 'Notă pentru secretar (opțional)',
  'childRequests.submit': 'Trimiteți cererea',
  'childRequests.sent':
    'Cererea a fost trimisă. Copilul apare la Copiii mei după aprobarea unui secretar.',
  'childRequests.mine': 'Cererile mele',
  'childRequests.loading': 'Se încarcă cererile…',
  'childRequests.empty': 'Nicio cerere încă.',
  'childRequests.withdraw': 'Retrageți',
  'childRequests.reason': 'Motiv',
  'childRequests.status.pending': 'Așteaptă verificarea',
  'childRequests.status.approved': 'Aprobată',
  'childRequests.status.rejected': 'Respinsă',
  'childRequests.status.withdrawn': 'Retrasă',
  'childRequests.review.title': 'Copii solicitați de părinți',
  'childRequests.review.intro':
    'Înainte de aprobare, verificați că solicitantul este într-adevăr părintele sau tutorele copilului. Alegeți sportivul la care se referă cererea sau creați o fișă nouă de sportiv; aprobarea deschide imediat o legătură aprobată cu tutorele, cu permisiunile lăsate bifate.',
  'childRequests.review.saved': 'Decizia a fost salvată.',
  'childRequests.review.empty': 'Nicio cerere în așteptare.',
  'childRequests.review.match': 'Despre ce sportiv este vorba?',
  'childRequests.review.exact': 'același nume și aceeași dată de naștere',
  'childRequests.review.newAthlete': 'Creați o fișă nouă de sportiv din această cerere',
  'childRequests.review.noCandidates':
    'Nu a fost găsit niciun sportiv cu această dată de naștere și acest nume.',
  'childRequests.review.approve': 'Aprobați și asociați',
  'childRequests.review.reject': 'Respingeți',
  'childRequests.review.reject.confirm': 'Confirmați respingerea',
  'inviteParent.title': 'Invitați un părinte',
  'inviteParent.intro':
    'Introduceți adresa de e-mail și numele părintelui. Acesta se autentifică prin linkul de invitație și apoi își adaugă copiii; nu vede niciun copil până când un secretar nu aprobă cererea. Dacă clubul are o adresă de expeditor, aplicația trimite invitația prin e-mail; linkul este afișat și o singură dată și este valabil 72 de ore.',
  'inviteParent.submit': 'Creați invitația',
  'guardianLinks.create.athletesHint':
    'Adaugă unul sau mai mulți sportivi; pentru fiecare se solicită o legătură separată.',
  'guardianLinks.create.chosenAthletes': 'Sportivi aleși',
  'guardianLinks.create.chosenGuardian': 'Tutore ales',
  'guardianLinks.create.approveNow': 'Aprobă legăturile acum (am verificat relația)',
  'guardianLinks.invite.open': 'Invită în aplicație',
  'guardianLinks.invite.hint':
    'Tutorele nu are încă un cont. Cu invitația se poate autentifica și vede acest copil cât timp legătura este aprobată.',
  'error.guardianLink.selfLink':
    'Nimeni nu poate fi propriul tutore și nimeni nu își poate aproba propriul acces de tutore.',
  'error.guardianLink.alreadyOpen':
    'Acest tutore are deja o legătură în așteptare sau aprobată cu acest sportiv pentru perioada respectivă.',
  'error.guardianLink.invalidState':
    'Această legătură a fost deja soluționată sau modificată. Reîncarcă lista și verifică starea ei.',
  'error.guardianLink.invalidValidity':
    'Perioada de valabilitate nu este validă: nu se poate încheia în trecut sau înainte de a începe.',
  'shell.foundationTitle': 'Fundația securizată este pregătită',
  'shell.foundationBody':
    'Zonele funcționale vor deveni disponibile după finalizarea autorizării și protecției datelor.',
  'shell.help':
    'Poți schimba limba oricând. Alegerea modifică doar etichetele; datele calendaristice, numerele și înregistrările stocate rămân neschimbate.',
  'shell.placeholder': 'Această zonă nu este încă activată.',
  'shell.skipToContent': 'Salt la conținutul principal',
  'login.signIn': 'Autentificare cu contul clubului',
  'login.error.loginFailed': 'Autentificarea nu s-a finalizat. Încercați din nou.',
  'login.error.providerUnavailable':
    'Serviciul de autentificare nu este disponibil acum. Încercați din nou peste câteva minute.',
  'error.unauthenticated': 'Autentificați-vă pentru a continua.',
  'error.originNotAllowed': 'Cererea a fost blocată deoarece nu provine din această aplicație.',
  'error.csrfInvalid':
    'Jetonul de securitate lipsește sau este expirat. Reîncărcați pagina și încercați din nou.',
  'page.landing': 'Bun venit',
  'help.landing':
    'După autentificare ajungeți la prezentarea generală a clubului. Dacă aparțineți mai multor cluburi, alegeți unul aici sau din meniul de sus; datele fiecărui club sunt complet separate. Dacă ați deschis o invitație înainte de autentificare, sunteți dus înapoi la ea pentru a o accepta. Dacă contul nu este încă legat de niciun club, alegeți Deschideți pagina invitației și lipiți codul invitației sau deschideți din nou linkul ei.',
  'account.loading': 'Se încarcă contul…',
  'account.noMembership':
    'Contul dumneavoastră nu este încă legat de un club. Cereți o invitație de la secretarul clubului, apoi deschideți linkul ei sau lipiți codul în pagina invitației.',
  'account.openInvitation': 'Deschideți pagina invitației',
  'account.chooseOrganization': 'Alegeți un club',
  'account.organization': 'Club',
  'account.signOut': 'Deconectare',
  'invite.tokenLabel': 'Cod de invitație',
  'invite.accept': 'Acceptă invitația',
  'invite.signInToAccept': 'Autentificați-vă pentru a accepta',
  'invite.createAccount': 'Creați un cont',
  'invite.accountHint':
    'Aveți deja un cont, de exemplu dintr-o invitație anterioară? Autentificați-vă. Dacă pagina de autentificare spune că adresa de e-mail este deja folosită, aveți un cont: autentificați-vă, folosind la nevoie linkul pentru parolă uitată.',
  'error.unexpected': 'A apărut o eroare. Încercați din nou.',
  'error.forbidden': 'Nu aveți permisiunea de a face acest lucru.',
  'error.mfaRequired':
    'Rolurile de personal necesită autentificare cu mai mulți factori. Deconectați-vă, apoi autentificați-vă din nou și completați al doilea factor.',
  'error.import.empty': 'Fișierul este gol.',
  'error.import.tooLarge': 'Fișierul este prea mare; limita este de 512 KB de text.',
  'error.import.tooManyRows':
    'Fișierul are mai mult de 1.000 de rânduri. Împărțiți-l în fișiere mai mici.',
  'error.import.tooManyColumns': 'Fișierul are prea multe coloane.',
  'error.import.cellTooLong': 'O celulă are mai mult de 500 de caractere.',
  'error.import.formula':
    'Fișierul conține o formulă sau o celulă care începe cu = sau @. Eliminați-o și încercați din nou.',
  'error.import.binary':
    'Se acceptă doar fișiere text CSV în UTF-8, nu foi de calcul sau alte fișiere binare.',
  'error.import.unterminatedQuote': 'O valoare între ghilimele nu este închisă.',
  'error.import.headerMismatch':
    'Primul rând trebuie să conțină exact coloanele șablonului. Descărcați șablonul și comparați.',
  'error.import.duplicateHeader': 'O denumire de coloană apare de două ori în primul rând.',
  'error.import.notStaged': 'Acest import este deja încheiat sau retras.',
  'error.import.unresolved':
    'Unele rânduri au încă erori sau necesită o decizie, deci nu s-a importat nimic.',
  'error.import.stale':
    'Datele clubului s-au schimbat de la verificarea fișierului, deci nu s-a importat nimic. Încărcați din nou fișierul.',
  'error.import.noDecisionNeeded': 'Acest rând nu necesită o decizie.',
  'error.import.invalidCandidate':
    'Alegeți unul dintre sportivii existenți afișați pentru acest rând.',
  'error.import.batchClosed': 'Acest import este închis; deciziile nu mai pot fi modificate.',
  'error.import.unknownKind': 'Tip de import necunoscut.',
  'error.billing.unknownAthlete': 'Acest sportiv nu aparține acestui club.',
  'error.billing.athleteNotOnAccount': 'Acest sportiv nu este atribuit acestui cont de facturare.',
  'error.billing.assignmentOverlap':
    'Acest sportiv are deja un cont de facturare pentru o parte din aceste date.',
  'error.billing.assignmentAlreadyEnded': 'Această atribuire are deja o dată de sfârșit.',
  'error.billing.invalidEnd': 'Data de sfârșit nu poate fi înainte de data de început.',
  'error.billing.accessAlreadyGranted':
    'Această persoană are deja acces la acest cont. Revocați-l mai întâi pentru a-l modifica.',
  'error.billing.accessAlreadyRevoked': 'Acest acces a fost deja revocat.',
  'error.billing.invalidValidity': 'Sfârșitul valabilității nu poate fi înainte de început.',
  'error.billing.currencyMismatch': 'Moneda nu corespunde contului de facturare.',
  'error.billing.accountClosed': 'Acest cont de facturare este închis.',
  'error.billing.periodClosed':
    'Această dată se află într-o perioadă de raportare închisă. Înregistrați operațiunea în perioada deschisă.',
  'error.billing.periodClose.notPast':
    'O perioadă poate fi închisă doar până la o zi dinaintea celei de azi.',
  'error.billing.periodClose.notAfterLast':
    'Registrul este deja închis până la această zi sau până la una ulterioară.',
  'error.billing.creditExceedsOutstanding':
    'O notă de credit nu poate depăși suma încă restantă a taxei. Dacă taxa este deja plătită, anulați mai întâi o alocare.',
  'error.billing.refundExceedsAvailable':
    'O rambursare nu poate depăși valoarea nealocată a plății. Dacă suma este deja alocată, anulați mai întâi alocarea.',
  'error.billing.alreadyReversed': 'Această înregistrare a fost deja anulată.',
  'error.billing.notReversible': 'Această înregistrare nu poate fi anulată.',
  'error.billing.paymentRefunded': 'O plată rambursată parțial nu poate fi anulată.',
  'error.billing.allocation.unknownCharge': 'Această taxă nu aparține contului plății.',
  'error.billing.allocation.duplicateCharge': 'O taxă poate apărea o singură dată într-o alocare.',
  'error.billing.allocation.notPositive': 'Suma alocată trebuie să fie mai mare decât zero.',
  'error.billing.allocation.exceedsOutstanding': 'Suma alocată depășește suma restantă a taxei.',
  'error.billing.allocation.exceedsPayment': 'Alocările depășesc valoarea nealocată a plății.',
  'error.billing.fee.planCurrencyChanged':
    'O versiune nouă a unui plan de taxe păstrează moneda planului. Pentru altă monedă, creați un plan nou.',
  'error.billing.fee.unknownAccount': 'Acest cont de facturare nu există.',
  'error.billing.fee.unknownPlan': 'Această versiune de plan de taxe nu există.',
  'error.billing.fee.planCurrencyMismatch': 'Moneda planului de taxe nu corespunde contului.',
  'error.billing.fee.versionExists':
    'Tocmai a fost creată o altă versiune a acestui plan. Reîncărcați pagina și încercați din nou.',
  'error.billing.fee.assignmentOverlap':
    'Acest sportiv are deja o taxă pe acest cont pentru o parte din aceste date. Încheiați-o mai întâi.',
  'error.billing.fee.periodTooFarAhead':
    'O rulare a taxelor poate acoperi cel mult luna curentă sau luna următoare.',
  'error.billing.fee.tooManyAssignments':
    'Prea multe alocări de taxe ating această lună pentru a fi rulate deodată.',
  'error.billing.fee.reviewNotApplicable':
    'Doar prima taxă de la mijlocul lunii, aflată în așteptarea verificării, poate primi o sumă verificată.',
  'error.billing.fee.reviewExceedsPlan':
    'Prima taxă verificată nu poate fi mai mare decât taxa după reducere.',
  'error.idempotency.keyRequired': 'Această acțiune necesită antetul Idempotency-Key.',
  'error.idempotency.keyReused': 'Această cheie a fost deja folosită pentru o altă cerere.',
  'error.idempotency.inProgress':
    'O cerere anterioară cu această cheie încă rulează. Încercați din nou imediat.',
  'import.problem.required': 'este obligatoriu',
  'import.problem.too_long': 'este prea lung',
  'import.problem.invalid_date': 'nu este o dată validă în sistemul de date ales',
  'import.problem.date_in_future': 'este în viitor',
  'import.problem.invalid_email': 'nu este o adresă de e-mail validă',
  'import.problem.invalid_phone': 'nu este un număr de telefon valid',
  'import.problem.invalid_locale': 'trebuie să fie en, hu sau ro',
  'import.problem.invalid_relationship':
    'trebuie să fie parent, legal_guardian, grandparent sau other',
  'import.problem.end_before_start': 'este înainte de data de început',
  'import.problem.duplicate_in_file': 'repetă un rând anterior din acest fișier',
  'import.problem.unknown_athlete':
    'indică un sportiv care nu a fost încă importat din această sursă',
  'import.problem.athlete_not_active': 'indică un sportiv inactiv',
  'import.problem.membership_overlap':
    'se suprapune peste o perioadă de membru existentă a sportivului',
  'imports.title': 'Import de sportivi, tutori și perioade de membru',
  'imports.intro':
    'Încărcați un fișier CSV în UTF-8 creat din șablon. Nu se salvează nimic până nu verificați rândurile controlate și nu le confirmați.',
  'imports.kind': 'Ce importați',
  'imports.kind.athletes': 'Sportivi',
  'imports.kind.guardians': 'Legături de tutore (în așteptare)',
  'imports.kind.memberships': 'Perioade de membru în club',
  'imports.source': 'Numele sistemului sursă',
  'imports.sourceHelp':
    'Împreună cu ID-ul extern, recunoaște aceeași înregistrare la un nou import.',
  'imports.dateFormat': 'Sistemul de date din fișier',
  'imports.dateFormat.iso': 'An-lună-zi (2026-10-04)',
  'imports.dateFormat.dmy': 'Zi.lună.an (04.10.2026)',
  'imports.dateFormat.mdy': 'Lună/zi/an (10/04/2026)',
  'imports.file': 'Fișier CSV',
  'imports.fileTooLarge': 'Acest fișier are peste 512 KB.',
  'imports.template': 'Descărcați șablonul',
  'imports.stage': 'Verificați fișierul',
  'imports.staged':
    'Fișierul a fost verificat. Revizuiți rezultatul de mai jos înainte de confirmare.',
  'imports.list': 'Importuri',
  'imports.empty': 'Încă nu există importuri.',
  'imports.loading': 'Se încarcă importurile…',
  'imports.batchStatus.staged': 'Așteaptă verificarea',
  'imports.batchStatus.committed': 'Importat',
  'imports.batchStatus.cancelled': 'Retras',
  'imports.rowStatus.ready': 'Gata',
  'imports.rowStatus.error': 'Cu erori',
  'imports.rowStatus.needs_decision': 'Necesită decizie',
  'imports.rowStatus.already_imported': 'Deja importate',
  'imports.rowStatus.skipped': 'Omise',
  'imports.rowStatus.committed': 'Importate acum',
  'imports.review': 'Verificare',
  'imports.close': 'Închide',
  'imports.commit': 'Importați rândurile gata',
  'imports.commit.blocked':
    'Mai întâi corectați fișierul sau decideți pentru fiecare rând potrivit.',
  'imports.cancel': 'Retrageți acest fișier',
  'imports.cancel.confirm': 'Confirmați retragerea',
  'imports.result': 'Importul s-a încheiat.',
  'imports.result.created': 'Create',
  'imports.result.linked': 'Legate de sportivi existenți',
  'imports.result.skipped': 'Omise',
  'imports.result.alreadyImported': 'Deja importate',
  'imports.row': 'Rândul',
  'imports.rows.empty': 'Niciun rând în acest grup.',
  'imports.rows.loadMore': 'Mai multe rânduri',
  'imports.candidates': 'Sportivi existenți cu același nume și dată de naștere',
  'imports.decision.create': 'Creați un sportiv nou',
  'imports.decision.link': 'Aceeași persoană: legare',
  'imports.decision.skip': 'Omiteți acest rând',
  'imports.decision.made': 'Decizie',
  'imports.guardianNote':
    'Rândurile de tutori creează legături în așteptare, fără acces; un secretar aprobă fiecare legătură la Legături de tutori. Nimeni nu este invitat sau notificat.',
  'imports.athleteFirstNote':
    'Importați mai întâi sportivii. Rândurile de tutori și de perioade indică sportivul prin ID-ul extern din aceeași sursă.',
  'import.problem.invalid_amount':
    'trebuie să fie un număr întreg de subunități, fără separatori (25000 înseamnă 250,00)',
  'import.problem.invalid_currency': 'trebuie să fie RON, EUR sau HUF',
  'import.problem.currency_mismatch': 'nu este moneda acestui cont',
  'import.problem.invalid_balance_type': 'trebuie să fie due (datorie) sau credit',
  'import.problem.invalid_method': 'trebuie să fie cash, bank_transfer, card_terminal sau other',
  'import.problem.unknown_account': 'indică un cont care nu a fost încă importat din această sursă',
  'import.problem.account_closed': 'indică un cont închis',
  'import.problem.period_closed': 'se află într-o perioadă de raportare deja închisă',
  'import.problem.assignment_overlap':
    'se suprapune cu o altă asociere a sportivului la un cont de facturare',
  'import.problem.athlete_not_on_account': 'indică un sportiv care nu este asociat acestui cont',
  'imports.kind.billing_accounts': 'Conturi de facturare',
  'imports.kind.billing_assignments': 'Sportivi asociați conturilor',
  'imports.kind.opening_balances': 'Solduri de deschidere',
  'imports.kind.payments': 'Plăți',
  'billing.imports.title': 'Import de conturi, solduri de deschidere și plăți',
  'billing.imports.intro':
    'Verificați mai întâi fișierul CSV; nu se înregistrează nimic până nu importați rândurile gata. Un fișier doar adaugă înregistrări: taxele și plățile înregistrate nu sunt modificate sau suprascrise niciodată și nimeni nu este notificat.',
  'billing.imports.orderNote':
    'Importați în această ordine: conturi, apoi sportivii asociați conturilor, apoi soldurile de deschidere, apoi plățile. Sportivii trebuie importați înainte din aceeași sursă; rândurile indică conturile și sportivii prin ID-urile externe.',
  'billing.imports.openingNote':
    'Un sold de deschidere devine o taxă de deschidere (tip due, datată cu ziua as_of) sau un credit de deschidere (tip credit); nu este înregistrat niciodată ca plată istorică. Sumele sunt numere întregi de subunități: 25000 înseamnă 250,00.',
  'billing.imports.paymentsNote':
    'O plată importată își păstrează întreaga sumă drept credit nealocat; alocați-o ulterior din cont.',
  'imports.totals': 'Totalurile rândurilor valide – comparați-le cu tabelul sursă',
  'imports.totals.opening_due': 'Datorii de deschidere',
  'imports.totals.opening_credit': 'Credite de deschidere',
  'imports.totals.payment': 'Plăți',
  'imports.totals.rows': 'rânduri',
  'dashboard.secretary.title': 'Ce necesită atenția dumneavoastră',
  'dashboard.loading': 'Se încarcă…',
  'dashboard.missingGuardianLinks': 'Minori fără legătură de tutore',
  'dashboard.pendingGuardianLinks': 'Legături de tutori care așteaptă o decizie',
  'dashboard.pendingImports': 'Importuri care așteaptă verificarea',
  'dashboard.newJoiners': 'Membri noi în ultimele 30 de zile',
  'dashboard.inactiveAthletes': 'Sportivi activi fără o perioadă de membru curentă',
  'dashboard.evidenceNote':
    'Înregistrările și dovezile care expiră vor apărea aici după ce există înscrieri la competiții.',
  'dashboard.openAthletes': 'Deschideți pagina Sportivi',
  'hockeyProfile.title': 'Profil de hochei',
  'hockeyProfile.positions': 'Poziții preferate',
  'hockeyProfile.position.goalkeeper': 'Portar',
  'hockeyProfile.position.defender': 'Fundaș',
  'hockeyProfile.position.forward': 'Atacant',
  'hockeyProfile.stickHand': 'Mâna cu crosa',
  'hockeyProfile.stickHand.left': 'Stânga',
  'hockeyProfile.stickHand.right': 'Dreapta',
  'hockeyProfile.none': 'Nesetat',
  'hockeyAssessment.skatingSprint': 'Sprint în linie dreaptă pe patine',
  'hockeyAssessment.puckControlCourse': 'Parcurs de control al pucului',
  'hockeyAssessment.shootingAccuracy': 'Precizia șuturilor',
  'hockeyAssessment.offIceAgility': 'Parcurs de agilitate în afara gheții',
  'hockeyProfile.save': 'Salvați profilul de hochei',
  'hockeyProfile.saved': 'Profilul de hochei a fost salvat.',
  'error.changeRequest.notPending': 'Această cerere a fost deja soluționată sau retrasă.',
  'error.changeRequest.ownRequest': 'Nu puteți soluționa o cerere făcută de dumneavoastră.',
  'error.changeRequest.athleteChanged':
    'Datele sportivului s-au schimbat între timp. Reîncărcați și verificați din nou.',
  'error.childRequest.notPending': 'Această cerere a fost deja soluționată sau retrasă.',
  'error.childRequest.ownRequest':
    'Nu puteți decide asupra unei cereri făcute de dumneavoastră sau în care dumneavoastră sunteți tutorele.',
  'error.childRequest.noGuardianRecord':
    'Contul dumneavoastră nu este încă asociat cu o fișă de tutore în acest club. Rugați clubul să vă invite ca părinte.',
  'error.childRequest.unknownAthlete': 'Sportivul ales nu există în acest club.',
  'error.childRequest.alreadyPending': 'Aveți deja o cerere în așteptare pentru acest copil.',
  'changeRequests.title': 'Cereri de modificare',
  'changeRequests.open': 'Solicitați o modificare',
  'changeRequests.hint':
    'Completați doar ceea ce trebuie modificat. Cererea este verificată de un secretar; nimic nu se schimbă până la aprobare.',
  'changeRequests.note': 'Notă pentru secretar (opțional)',
  'changeRequests.submit': 'Trimiteți cererea',
  'changeRequests.cancel': 'Anulați',
  'changeRequests.sent': 'Cererea a fost trimisă spre verificare.',
  'changeRequests.withdraw': 'Retrageți',
  'changeRequests.status.pending': 'Așteaptă verificarea',
  'changeRequests.status.approved': 'Aprobată',
  'changeRequests.status.rejected': 'Respinsă',
  'changeRequests.status.withdrawn': 'Retrasă',
  'changeRequests.review.title': 'Cereri de modificare de verificat',
  'changeRequests.sensitive': 'nume sau dată de naștere: verificați un document',
  'changeRequests.approve': 'Aprobați și aplicați',
  'changeRequests.reject': 'Respingeți',
  'changeRequests.reject.confirm': 'Confirmați respingerea',
  'changeRequests.reason': 'Motiv',
  'error.notFound': 'Acest element nu există sau nu aveți acces la el.',
  'error.validation': 'Unele informații nu sunt valide. Verificați și încercați din nou.',
  'error.logo.invalidImage':
    'Imaginea nu este validă sau este prea mare. Alegeți o imagine PNG, JPEG sau WebP în limita de dimensiune.',
  'error.versionConflict':
    'Acest element a fost modificat de altcineva. Reîncărcați-l și încercați din nou.',
  'error.preconditionRequired':
    'Cererea nu precizează ce versiune modifică. Reîncărcați pagina și încercați din nou.',
  'error.invitation.invalid':
    'Acest cod de invitație nu este valid. Verificați dacă l-ați copiat complet.',
  'error.invitation.expired':
    'Această invitație a expirat. Cereți una nouă de la secretarul clubului.',
  'error.invitation.revoked':
    'Această invitație a fost retrasă. Cereți una nouă de la secretarul clubului.',
  'error.invitation.alreadyUsed':
    'Această invitație a fost deja folosită sau nu mai este în așteptare.',
  'error.invitation.ownInvitation': 'Nu puteți accepta o invitație creată chiar de dumneavoastră.',
  'error.invitation.membershipBlocked':
    'Calitatea dumneavoastră de membru al acestui club nu poate accepta această invitație. Contactați secretarul clubului.',
  'error.invitation.roleNotAllowed': 'Nu aveți permisiunea de a invita persoane pentru acest rol.',
  'error.invitation.personRequired':
    'Invitațiile pentru tutori și sportivi necesită o legătură verificată cu o persoană; cele pentru personal nu pot avea una.',
  'error.invitation.stillPending':
    'O invitație în așteptare nu poate fi ștearsă; retrageți-o mai întâi. Reîncărcați lista și încercați din nou.',
  'error.invitation.unknownDepartment': 'Departamentul selectat nu există în acest club.',
  'error.role.notAssignable':
    'Acest rol nu poate fi atribuit aici. Rolurile de tutore și de sportiv se obțin doar printr-o invitație cu o legătură verificată cu o persoană.',
  'error.role.memberInactive':
    'Această calitate de membru nu este activă, deci nu poate primi un rol.',
  'error.role.unknownDepartment': 'Departamentul selectat nu există în acest club.',
  'error.role.alreadyAssigned': 'Această persoană deține deja acest rol în sfera selectată.',
  'error.role.alreadyRevoked': 'Acest rol a fost deja retras.',
  'error.role.invalidValidity': 'Data de încheiere trebuie să fie în viitor.',
  'error.role.lastAdministrator':
    'Clubul are nevoie de cel puțin un administrator activ. Atribuiți mai întâi rolul altei persoane.',
  'error.member.notChangeable':
    'Această calitate de membru nu mai este într-o stare care permite această modificare. Reîncărcați lista și încercați din nou.',
  'error.member.lastAdministrator':
    'Clubul are nevoie de cel puțin un administrator activ. Atribuiți mai întâi rolul altei persoane.',
  'teams.department': 'Departament',
  'teams.noDepartments': 'Nu există niciun departament de afișat.',
  'teams.loading': 'Se încarcă…',
  'teams.saved': 'Salvat.',
  'teams.season.select': 'Sezon',
  'teams.season.none': 'Încă nu există sezoane.',
  'teams.season.name': 'Numele sezonului',
  'teams.season.startsOn': 'Începe la',
  'teams.season.endsOn': 'Se termină la',
  'teams.season.status.draft': 'Ciornă',
  'teams.season.status.active': 'Activ',
  'teams.season.status.closed': 'Închis',
  'teams.season.create.title': 'Adaugă un sezon',
  'teams.season.create.submit': 'Adaugă sezonul',
  'teams.season.activate': 'Activează sezonul',
  'teams.season.close': 'Închide sezonul',
  'teams.season.close.confirm': 'Confirmă închiderea',
  'teams.teams.title': 'Echipe',
  'teams.teams.empty': 'Încă nu există echipe în acest sezon.',
  'teams.team.name': 'Numele echipei',
  'teams.team.category': 'Categorie de vârstă',
  'teams.team.division': 'Divizie de competiție (opțional)',
  'teams.team.ordinal': 'Numărul echipei',
  'teams.team.create.title': 'Adaugă o echipă',
  'teams.team.create.submit': 'Adaugă echipa',
  'teams.category.U7_U9': 'U7–U9',
  'teams.category.U11': 'U11',
  'teams.category.U13': 'U13',
  'teams.category.U15': 'U15',
  'teams.category.U17': 'U17',
  'teams.category.U20': 'U20',
  'teams.groups.title': 'Grupe de antrenament',
  'teams.groups.empty': 'Încă nu există grupe de antrenament în acest sezon.',
  'teams.group.name': 'Numele grupei',
  'teams.group.create.title': 'Adaugă o grupă de antrenament',
  'teams.group.create.submit': 'Adaugă grupa',
  'teams.roster.show': 'Arată membrii',
  'teams.roster.hide': 'Ascunde membrii',
  'teams.roster.empty': 'Niciun membru.',
  'teams.roster.includeEnded': 'Include și repartizările încheiate',
  'teams.roster.from': 'De la',
  'teams.roster.until': 'Până la',
  'teams.roster.shirt': 'Număr de tricou',
  'teams.roster.add.title': 'Adaugă un membru',
  'teams.roster.add.athlete': 'Caută un sportiv după nume',
  'teams.roster.add.noMatches': 'Niciun rezultat',
  'teams.roster.add.submit': 'Adaugă în lot',
  'teams.roster.end': 'Încheie repartizarea',
  'teams.roster.end.confirm': 'Confirmă încheierea',
  'teams.roster.openEnded': 'fără dată de sfârșit',
  'error.structure.unknownCategory':
    'Această categorie de vârstă nu este disponibilă pentru sportul departamentului.',
  'error.structure.invalidPeriod': 'Data de sfârșit nu poate fi înaintea datei de început.',
  'error.structure.invalidState':
    'Acest sezon nu mai este într-o stare care permite această modificare. Reîncarcă pagina și încearcă din nou.',
  'error.structure.notOpen':
    'Sezonul sau echipa nu mai este deschis pentru modificări (închis sau arhivat).',
  'error.structure.alreadyExists':
    'Există deja un element cu acest nume în acest departament și sezon.',
  'error.structure.membershipOverlap':
    'Acest sportiv are deja o repartizare aici care se suprapune cu aceste date.',
  'error.structure.shirtNumberTaken':
    'Acest număr de tricou este deja folosit de alt membru în aceste date.',
  'error.structure.athleteNotActive':
    'Doar sportivii activi pot fi repartizați într-o echipă sau grupă.',
  'error.structure.alreadyEnded': 'Această repartizare are deja o dată de sfârșit.',
  'error.structure.invalidEnd': 'Data de sfârșit nu poate fi înaintea începerii repartizării.',
  'error.clubMembership.overlap':
    'Acest sportiv are deja o perioadă de membru care se suprapune cu aceste date.',
  'error.clubMembership.athleteNotActive': 'Doar sportivii activi pot deveni membri ai clubului.',
  'error.clubMembership.alreadyEnded': 'Această perioadă de membru are deja o dată de sfârșit.',
  'error.clubMembership.invalidEnd':
    'Data de sfârșit nu poate fi înaintea începerii perioadei de membru.',
  'calendar.loading': 'Se încarcă evenimentele…',
  'calendar.empty': 'Nu există evenimente în această perioadă.',
  'calendar.saved': 'Salvat.',
  'calendar.loadMore': 'Arată mai multe evenimente',
  'calendar.staff.title': 'Calendarul clubului',
  'calendar.family.title': 'Evenimente viitoare',
  'calendar.family.empty': 'Nu există evenimente viitoare.',
  'calendar.filter.from': 'De la',
  'calendar.filter.to': 'Până la',
  'calendar.filter.department': 'Departament',
  'calendar.filter.status': 'Stare',
  'calendar.filter.all': 'Toate',
  'calendar.type.on_ice_training': 'Antrenament pe gheață',
  'calendar.type.off_ice_training': 'Antrenament în afara gheții',
  'calendar.type.match': 'Meci',
  'calendar.type.assessment': 'Evaluare',
  'calendar.type.meeting': 'Ședință',
  'calendar.status.draft': 'Ciornă',
  'calendar.status.published': 'Publicat',
  'calendar.status.cancelled': 'Anulat',
  'calendar.status.completed': 'Încheiat',
  'calendar.field.type': 'Tip',
  'calendar.field.title': 'Titlu',
  'calendar.field.date': 'Data',
  'calendar.field.startTime': 'Începe',
  'calendar.field.endTime': 'Se termină',
  'calendar.field.location': 'Locație (opțional)',
  'calendar.field.resource': 'Patinoar, zonă sau sală',
  'calendar.field.noResource': 'Nicio resursă necesară',
  'calendar.field.capacity': 'Capacitate (opțional)',
  'calendar.field.arrival': 'Sosire cu atâtea minute înainte de început (opțional)',
  'calendar.field.rsvpHours': 'Familiile pot răspunde până cu atâtea ore înainte de început',
  'calendar.create.title': 'Adaugă un eveniment',
  'calendar.create.submit': 'Adaugă evenimentul',
  'calendar.create.submitSeries': 'Adaugă seria recurentă',
  'calendar.create.repeat': 'Se repetă după program',
  'calendar.create.weekdays': 'Se repetă în zilele de',
  'calendar.create.until': 'Se repetă până la (opțional)',
  'calendar.create.publishAll': 'Publică acum fiecare apariție',
  'calendar.create.leadSelf': 'Eu conduc această sesiune',
  'calendar.create.created':
    'Evenimentul a fost adăugat ca ciornă. Deschideți-l pentru a-l publica.',
  'calendar.create.seriesResult': 'Evenimente create:',
  'calendar.create.seriesConflicts': 'Rămase ca ciorne, deoarece resursa era deja ocupată:',
  'calendar.create.seriesUnpublished': 'Rămase ca ciorne, deoarece nu au putut fi publicate:',
  'calendar.audience.title': 'Cine este invitat',
  'calendar.audience.season': 'Sezon',
  'calendar.audience.teams': 'Echipe',
  'calendar.audience.groups': 'Grupe de antrenament',
  'calendar.audience.none': 'Nu există echipe sau grupe în acest sezon.',
  'calendar.audience.athlete': 'Adaugă un sportiv după nume',
  'calendar.audience.noMatches': 'Niciun rezultat',
  'calendar.audience.remove': 'Elimină',
  'calendar.audience.hint':
    'Bifează echipe sau grupe întregi, sau deschide o listă și bifează doar jucătorii de care ai nevoie, din oricâte echipe.',
  'calendar.audience.pickFromRoster': 'Alege jucători',
  'calendar.audience.hideRoster': 'Ascunde jucătorii',
  'calendar.audience.rosterEmpty': 'Nimeni nu este azi pe această listă.',
  'calendar.audience.picked': 'Invitați individual',
  'calendar.audience.publishedHint':
    'La salvare participanții se actualizează imediat: cei nou invitați sunt adăugați, iar cine a răspuns deja sau are prezența înregistrată își păstrează locul.',
  'calendar.action.restore': 'Restabilește evenimentul',
  'calendar.series.title': 'Serie recurentă',
  'calendar.series.everyWeek': 'În fiecare săptămână: {days}',
  'calendar.series.everyNthWeek': 'La fiecare {weeks} săptămâni: {days}',
  'calendar.series.interval': 'Repetare',
  'calendar.series.intervalOne': 'În fiecare săptămână',
  'calendar.series.intervalMany': 'La fiecare {weeks} săptămâni',
  'calendar.series.noEnd': 'Fără dată de sfârșit.',
  'calendar.series.until': 'Până la {date}.',
  'calendar.series.ended': 'Această serie s-a încheiat; nu se mai planifică nimic nou.',
  'calendar.series.upcoming': 'Următoarele sesiuni',
  'calendar.series.upcomingHint':
    'Debifează o sesiune pentru a o anula doar pe aceea, de exemplu antrenamentul de mâine; bifeaz-o din nou pentru a o readuce.',
  'calendar.series.none': 'Nicio sesiune planificată în lunile următoare.',
  'calendar.series.defaultCancelReason': 'Această sesiune este anulată.',
  'calendar.series.defaultRescheduleReason': 'Programul antrenamentelor s-a schimbat.',
  'calendar.series.ownTime': 'Modificată separat',
  'calendar.series.confirmCancel': 'Anulează sesiunea',
  'calendar.series.confirmRestore': 'Readu sesiunea',
  'calendar.series.restoreAnyway': 'Restabilește oricum',
  'calendar.series.keep': 'Lasă așa',
  'calendar.series.notify': 'Anunță familiile invitate (se trimite după activarea notificărilor)',
  'calendar.series.cancelledOne': 'Sesiunea este anulată.',
  'calendar.series.restoredOne': 'Sesiunea are loc din nou.',
  'calendar.series.rescheduled':
    'Program schimbat: {kept} sesiuni păstrate, {cancelled} anulate, {created} adăugate.',
  'calendar.series.change': 'Schimbă programul',
  'calendar.series.changeHint':
    'Din ziua aleasă, sesiunile din zilele care rămân își păstrează răspunsurile și prezența și trec la noua oră; sesiunile din zilele eliminate sunt anulate cu motivul de mai jos; zilele noi se adaugă. Sesiunile anterioare nu se schimbă.',
  'calendar.series.fromDate': 'Se aplică de la',
  'calendar.series.removedReason': 'Motivul afișat la sesiunile eliminate',
  'calendar.series.saveChange': 'Salvează programul nou',
  'calendar.weekday.1': 'Luni',
  'calendar.weekday.2': 'Marți',
  'calendar.weekday.3': 'Miercuri',
  'calendar.weekday.4': 'Joi',
  'calendar.weekday.5': 'Vineri',
  'calendar.weekday.6': 'Sâmbătă',
  'calendar.weekday.7': 'Duminică',
  'calendar.detail.open': 'Deschide',
  'calendar.detail.close': 'Închide',
  'calendar.detail.resource': 'Resursă',
  'calendar.detail.arrival': 'Sosire până la',
  'calendar.detail.capacity': 'Capacitate',
  'calendar.detail.deadline': 'Răspunsuri până la',
  'calendar.detail.series': 'Face parte dintr-o serie recurentă.',
  'calendar.detail.exception': 'Această apariție a fost editată separat.',
  'calendar.detail.notReserved':
    'Resursa nu este încă rezervată, deci evenimentul nu poate fi publicat. Eliberați intervalul sau alegeți altă resursă.',
  'calendar.detail.cancelReason': 'Motivul anulării',
  'calendar.action.publish': 'Publică',
  'calendar.action.publishAnyway': 'Publică oricum',
  'calendar.action.cancel': 'Anulează evenimentul',
  'calendar.action.cancelReason': 'Motiv (familiile îl vor vedea)',
  'calendar.action.cancelConfirm': 'Confirmă anularea',
  'calendar.action.cancelFuture': 'Anulează și aparițiile următoare',
  'calendar.action.complete': 'Marchează ca încheiat',
  'calendar.action.edit': 'Editează',
  'calendar.action.save': 'Salvează modificările',
  'calendar.action.discard': 'Renunță la editare',
  'calendar.scope.title': 'Aplică modificarea la',
  'calendar.scope.this': 'Doar această apariție',
  'calendar.scope.future': 'Această apariție și toate următoarele',
  'calendar.overlap.notice':
    'Unii sportivi sunt deja așteptați la un alt eveniment la aceeași oră.',
  'calendar.participants.title': 'Participanți',
  'calendar.participants.empty':
    'Încă nu este așteptat nimeni. Participanții sunt adăugați la publicare.',
  'calendar.participants.answers': 'Răspunsuri',
  'calendar.rsvp.yes': 'Da',
  'calendar.rsvp.no': 'Nu',
  'calendar.rsvp.tentative': 'Poate',
  'calendar.rsvp.none': 'Fără răspuns',
  'calendar.rsvp.corrected': 'Corectat după termen',
  'calendar.rsvp.correct': 'Corectează răspunsul',
  'calendar.rsvp.reason': 'Motiv (obligatoriu după termen)',
  'calendar.rsvp.save': 'Salvează răspunsul',
  'calendar.refresh.check': 'Verifică modificările de apartenență',
  'calendar.refresh.upToDate': 'Participanții corespund echipelor și grupelor.',
  'calendar.refresh.toAdd': 'De adăugat',
  'calendar.refresh.toRemove': 'De eliminat',
  'calendar.refresh.retained': 'Rămân, deoarece au răspuns sau au prezență înregistrată',
  'calendar.refresh.apply': 'Aplică modificările',
  'calendar.attendance.title': 'Prezență',
  'calendar.attendance.present': 'Prezent',
  'calendar.attendance.late': 'Întârziat',
  'calendar.attendance.absent_excused': 'Motivat',
  'calendar.attendance.absent_unexcused': 'Absent',
  'calendar.attendance.not_recorded': 'Neînregistrat',
  'calendar.attendance.markAll': 'Marchează pe toți prezenți',
  'calendar.attendance.save': 'Salvează prezența',
  'calendar.attendance.unsaved': 'Modificări nesalvate',
  'calendar.attendance.saved': 'Prezența a fost salvată.',
  'calendar.attendance.conflict':
    'Altcineva a modificat acest rând; este afișată înregistrarea sa. Alegeți din nou pentru a o înlocui.',
  'calendar.attendance.conflictSummary': 'Rânduri modificate de altcineva:',
  'calendar.attendance.notOpen': 'Prezența poate fi înregistrată după publicarea evenimentului.',
  'calendar.attendance.readOnly': 'Puteți vedea prezența, dar nu o puteți înregistra.',
  'calendar.summary.title': 'Rata de prezență',
  'calendar.summary.show': 'Arată ratele de prezență pentru această perioadă',
  'calendar.summary.athlete': 'Sportiv',
  'calendar.summary.rate': 'Rată',
  'calendar.summary.total': 'Total',
  'calendar.summary.empty': 'Nu există prezență înregistrată în această perioadă.',
  'calendar.summary.definition':
    'Rata de prezență = (prezent + întârziat) ÷ (prezent + întârziat + absențe motivate + absențe nemotivate) în perioada selectată. Evenimentele anulate, rândurile neînregistrate și sportivii care nu au fost participanți nu se numără. Absențele motivate sunt afișate separat.',
  'calendar.family.attending': 'Participă?',
  'calendar.family.answer': 'Răspuns',
  'calendar.family.closed': 'Răspunsurile sunt închise.',
  'calendar.family.cancelledNotice': 'Acest eveniment a fost anulat.',
  'calendar.venues.title': 'Locații și resurse',
  'calendar.venues.intro':
    'Un patinoar cu zone rezervabile se introduce ca patinoar cu zone sub el. Rezervarea întregului patinoar blochează toate zonele; timpul de curățare după o rezervare ține departe următoarea rezervare.',
  'calendar.venues.empty': 'Încă nu există locații.',
  'calendar.venue.name': 'Numele locației',
  'calendar.venue.add': 'Adaugă locația',
  'calendar.resource.name': 'Numele resursei',
  'calendar.resource.kind': 'Tip',
  'calendar.resource.parent': 'Face parte din',
  'calendar.resource.none': 'Nimic (nivel superior)',
  'calendar.resource.surface': 'Suprafață',
  'calendar.resource.setup': 'Minute de pregătire înainte de rezervare',
  'calendar.resource.cleanup': 'Minute de curățare după rezervare',
  'calendar.resource.add': 'Adaugă resursa',
  'calendar.resourceKind.rink': 'Patinoar',
  'calendar.resourceKind.zone': 'Zonă',
  'calendar.resourceKind.room': 'Sală',
  'calendar.resourceKind.field': 'Teren',
  'calendar.surface.ice': 'Gheață',
  'calendar.surface.dryland': 'Uscat',
  'calendar.surface.other': 'Altele',
  'error.scheduling.invalidTimeZone': 'Acest fus orar nu este valid.',
  'error.scheduling.invalidSchedule':
    'Sfârșitul trebuie să fie după început, iar un eveniment nu poate dura mai mult de două săptămâni.',
  'error.scheduling.unknownResource':
    'Această locație sau resursă nu este disponibilă pentru eveniment.',
  'error.scheduling.unknownAudience':
    'O echipă, o grupă sau un sportiv din lista de invitați nu aparține acestui departament.',
  'error.scheduling.unknownStaff':
    'Personalul trebuie să fie antrenori activi ai acestui departament.',
  'error.scheduling.unknownVenue': 'Această locație nu există.',
  'error.scheduling.invalidParent': 'Resursa părinte trebuie să fie în aceeași locație.',
  'error.scheduling.alreadyExists': 'Există deja un element cu acest nume aici.',
  'error.scheduling.resourceConflict':
    'Resursa este deja rezervată la această oră, inclusiv timpul de pregătire și curățare. Alegeți altă oră sau altă resursă.',
  'error.scheduling.staffConflict': 'Un antrenor numit aici are deja alt eveniment la această oră.',
  'error.scheduling.athleteOverlap':
    'Unii sportivi sunt deja așteptați la un alt eveniment publicat la această oră. Publicați oricum pentru a confirma.',
  'error.scheduling.capacityExceeded':
    'Numărul sportivilor depășește capacitatea evenimentului sau a resursei.',
  'error.scheduling.invalidState':
    'Evenimentul nu mai este într-o stare care permite acest lucru. Reîncărcați și încercați din nou.',
  'error.scheduling.notEditable': 'Un eveniment anulat sau încheiat nu mai poate fi modificat.',
  'error.scheduling.noAudience':
    'Alegeți cel puțin o echipă, o grupă sau un sportiv înainte de publicare.',
  'error.scheduling.rsvpClosed':
    'Termenul de răspuns a trecut. Rugați un antrenor să corecteze răspunsul.',
  'error.scheduling.rsvpNotAllowed': 'Se acceptă răspunsuri doar pentru evenimente publicate.',
  'error.scheduling.rsvpReasonRequired':
    'Indicați un motiv pentru corectarea unui răspuns după termen.',
  'error.scheduling.attendanceNotOpen':
    'Prezența poate fi înregistrată doar pentru evenimente publicate sau încheiate.',
  'error.scheduling.seriesInvalid':
    'Această serie săptămânală nu poate fi creată sau modificată astfel.',
  'error.scheduling.seriesNotOccurrence':
    'Acest eveniment nu face parte dintr-o serie săptămânală.',
  'error.scheduling.reschedulePast': 'Un program nou poate începe doar de azi sau mai târziu.',
  'training.loading': 'Se încarcă…',
  'training.saved': 'Salvat.',
  'training.drills.title': 'Exerciții',
  'training.drills.empty': 'Încă nu există exerciții.',
  'training.drill.title': 'Titlu (în limba curentă)',
  'training.drill.minutes': 'Durată (minute)',
  'training.drill.equipment': 'Echipament (separat prin virgulă)',
  'training.drill.instructions': 'Instrucțiuni pentru antrenor (doar personalul)',
  'training.drill.protocol': 'Protocol (opțional)',
  'training.drill.add': 'Adaugă exercițiul',
  'training.drill.edit': 'Editează ca versiune nouă',
  'training.drill.newVersion': 'Salvează ca versiune nouă',
  'training.drill.version': 'Versiune',
  'training.drill.department': 'Disponibil pentru',
  'training.drill.wholeClub': 'Tot clubul',
  'training.plans.title': 'Planuri de antrenament',
  'training.plans.empty': 'Încă nu există planuri.',
  'training.plan.new': 'Plan nou',
  'training.plan.open': 'Deschide',
  'training.plan.close': 'Închide',
  'training.plan.state.draft': 'Ciornă',
  'training.plan.state.published': 'Publicat',
  'training.plan.state.archived': 'Arhivat',
  'training.plan.title': 'Titlul planului',
  'training.plan.objective': 'Obiectiv (opțional)',
  'training.plan.sessionMinutes': 'Durata sesiunii (minute)',
  'training.plan.prepMinutes': 'Pregătire (minute)',
  'training.plan.breakMinutes': 'Pauze (minute)',
  'training.plan.override': 'Motiv pentru planificarea a mai mult decât încape (opțional)',
  'training.plan.active': 'Timp activ planificat',
  'training.plan.available': 'disponibil',
  'training.plan.minutes': 'min',
  'training.plan.fits': 'Planul încape în sesiune.',
  'training.plan.doesNotFit':
    'Planul este mai lung decât permite sesiunea. Scurtați-l sau indicați un motiv.',
  'training.plan.blocks': 'Blocuri',
  'training.plan.versions': 'Versiuni',
  'training.block.objective': 'Obiectivul blocului',
  'training.block.minutes': 'Minute',
  'training.block.drill': 'Exercițiu',
  'training.block.noDrill': 'Fără exercițiu',
  'training.block.intensity': 'Intensitate',
  'training.block.equipment': 'Echipament',
  'training.block.surface': 'Suprafață',
  'training.block.notes': 'Notițe pentru antrenor (nu sunt afișate familiilor)',
  'training.block.familyVisible': 'Arată un rezumat familiilor',
  'training.block.familySummary': 'Rezumat pentru familii',
  'training.block.add': 'Adaugă bloc',
  'training.block.remove': 'Elimină blocul',
  'training.block.up': 'Mută în sus',
  'training.block.down': 'Mută în jos',
  'training.block.stationsNote': 'La stații paralele, blocul durează cât cea mai lungă stație.',
  'training.station.add': 'Adaugă stație paralelă',
  'training.station.label': 'Stație',
  'training.station.remove': 'Elimină stația',
  'training.intensity.low': 'Scăzută',
  'training.intensity.medium': 'Medie',
  'training.intensity.high': 'Ridicată',
  'training.action.create': 'Creează planul',
  'training.action.save': 'Salvează ciorna',
  'training.action.publish': 'Publică versiunea',
  'training.action.newDraft': 'Începe o versiune nouă din aceasta',
  'training.action.frozen':
    'Această versiune este publicată și nu mai poate fi modificată. Începeți o versiune nouă pentru modificări.',
  'training.attach.title': 'Plan de antrenament',
  'training.attach.none': 'Fără plan',
  'training.attach.save': 'Folosește acest plan',
  'training.attach.override': 'Motiv pentru folosirea unui plan mai lung decât sesiunea',
  'training.attach.help':
    'Se pot folosi doar versiuni publicate. Modificarea ulterioară a șablonului nu schimbă o sesiune care l-a folosit deja.',
  'calendar.family.plan': 'Planul sesiunii',
  'error.training.unknownDrill': 'Un exercițiu din plan nu este disponibil acestui departament.',
  'error.training.invalidState': 'Această versiune nu mai este ciornă.',
  'error.training.draftExists': 'Planul are deja o ciornă. Finalizați-o sau publicați-o mai întâi.',
  'error.training.activeTimeExceeds':
    'Timpul activ planificat este mai lung decât permite sesiunea după pregătire și pauze. Scurtați planul sau indicați un motiv.',
  'error.training.planDoesNotFit':
    'Acest plan este mai lung decât permite evenimentul după pregătire și pauze. Indicați un motiv pentru a-l folosi oricum.',
  'error.training.planNotPublished':
    'Pentru un eveniment se poate folosi doar o versiune publicată a planului.',
  'error.training.notEditable':
    'O versiune publicată nu poate fi modificată. Începeți o versiune nouă.',
  'error.assessment.codeTaken': 'Această cheie de protocol este deja folosită în club.',
  'error.assessment.unknownDefinition': 'Acest protocol nu există.',
  'error.assessment.unknownDefinitionVersion':
    'Un protocol din sesiune nu este disponibil pentru acest departament.',
  'error.assessment.unknownAthlete':
    'Un sportiv din sesiune nu se antrenează în acest departament.',
  'error.assessment.unknownEvent':
    'Evenimentul ales nu este un eveniment de evaluare al acestui departament.',
  'error.assessment.unitMismatch':
    'Unitatea de măsură nu corespunde protocolului. Valorile se înregistrează numai în unitatea proprie a protocolului.',
  'error.assessment.resultPublished':
    'Acest rezultat este publicat. Începeți o corectură pentru a-l modifica.',
  'error.assessment.notCorrectable': 'Se poate corecta doar un rezultat publicat.',
  'error.assessment.draftExists':
    'Acest rezultat are deja o corectură nepublicată. Finalizați-o sau publicați-o mai întâi.',
  'error.assessment.noCorrection': 'Acest rezultat nu are o corectură nepublicată de anulat.',
  'error.assessment.nothingToPublish': 'Nu există rezultate în ciornă de publicat.',
  'error.assessment.notAParticipant': 'Acest sportiv sau protocol nu face parte din sesiune.',
  'error.assessment.definition.unitRequired': 'Indicați unitatea în care se măsoară valorile.',
  'error.assessment.definition.durationUnit': 'O durată se înregistrează întotdeauna în secunde.',
  'error.assessment.definition.boundsInvalid':
    'Cea mai mică valoare validă trebuie să fie un număr care nu depășește cea mai mare, cu cel mult atâtea zecimale cât precizia.',
  'error.assessment.definition.aggregationNotAllowed':
    'Media se poate folosi doar pentru numere și durate.',
  'error.assessment.definition.rubricLevels':
    'O grilă de evaluare are între 2 și 10 niveluri, fiecare cu o descriere.',
  'error.assessment.definition.notApplicable':
    'Această setare nu se aplică acestui tip de valoare.',
  'error.assessment.value.notANumber': 'Introduceți un număr.',
  'error.assessment.value.tooManyDecimals': 'Are mai multe zecimale decât permite protocolul.',
  'error.assessment.value.negativeDuration': 'O durată nu poate fi negativă.',
  'error.assessment.value.belowMinimum': 'Este sub cea mai mică valoare validă.',
  'error.assessment.value.aboveMaximum': 'Este peste cea mai mare valoare validă.',
  'error.assessment.value.notBoolean': 'Folosiți da sau nu.',
  'error.assessment.value.notRubricLevel': 'Alegeți unul dintre nivelurile grilei.',
  'error.assessment.value.required':
    'O încercare validă are nevoie de o valoare; zero este o valoare.',
  'error.assessment.value.notAllowed': 'O încercare invalidă sau neefectuată nu are valoare.',
  'error.assessment.value.tooManyAttempts': 'Acest protocol permite mai puține încercări.',
  'error.assessment.value.noAttempts': 'Înregistrați cel puțin o încercare.',
  'error.assessment.selection.required': 'Alegeți încercarea care contează.',
  'error.assessment.selection.invalid': 'Încercarea aleasă trebuie să fie validă.',
  'error.assessment.selection.notAllowed':
    'Acest protocol alege rezultatul automat; nu alegeți o încercare.',
  'error.assessment.selection.reasonRequired': 'Indicați motivul alegerii acestei încercări.',
  'error.assessment.selection.meanNotAllowed':
    'Media se poate folosi doar pentru numere și durate.',
  'assessments.loading': 'Se încarcă…',
  'assessments.saved': 'Salvat.',
  'assessments.protocols.title': 'Protocoale',
  'assessments.protocols.empty': 'Încă nu există protocoale.',
  'assessments.protocols.add': 'Adaugă protocol',
  'assessments.protocols.newVersion': 'Salvează ca versiune nouă',
  'assessments.protocols.edit': 'Editează ca versiune nouă',
  'assessments.protocols.cancel': 'Anulează',
  'assessments.protocol.version': 'Versiunea',
  'assessments.protocol.department': 'Disponibil pentru',
  'assessments.protocol.wholeClub': 'Întregul club',
  'assessments.protocol.code': 'Cheie (litere mici, cifre și cratime)',
  'assessments.protocol.title': 'Titlu (în limba curentă)',
  'assessments.protocol.instructions': 'Instrucțiuni pentru antrenor (opțional)',
  'assessments.protocol.valueType': 'Tipul rezultatului',
  'assessments.protocol.unit': 'Unitate de măsură',
  'assessments.protocol.precision': 'Zecimale',
  'assessments.protocol.minimum': 'Cea mai mică valoare validă',
  'assessments.protocol.maximum': 'Cea mai mare valoare validă',
  'assessments.protocol.direction': 'Mai bine când',
  'assessments.protocol.attempts': 'Încercări permise',
  'assessments.protocol.aggregation': 'Rezultatul contează ca',
  'assessments.protocol.allowOutOfRange':
    'Acceptă valori în afara celei mai mici și celei mai mari valori',
  'assessments.protocol.ratioScale': 'Variația procentuală are sens pentru acest protocol',
  'assessments.protocol.rubricLevel': 'Descrierea nivelului',
  'assessments.protocol.addLevel': 'Adaugă nivel',
  'assessments.protocol.removeLevel': 'Șterge ultimul nivel',
  'assessments.protocol.distance': 'Distanța',
  'assessments.protocol.course': 'Configurația traseului',
  'assessments.protocol.surface': 'Suprafața',
  'assessments.protocol.method': 'Metoda',
  'assessments.protocol.contextHint':
    'Distanța, traseul, suprafața și metoda se păstrează cu fiecare rezultat. Schimbarea oricăreia începe o serie nouă în graficele de progres.',
  'assessments.valueType.numeric': 'Număr',
  'assessments.valueType.duration': 'Durată (secunde)',
  'assessments.valueType.boolean': 'Da sau nu',
  'assessments.valueType.rubric': 'Grilă de evaluare (niveluri)',
  'assessments.direction.lower_is_better': 'Mai mic este mai bine',
  'assessments.direction.higher_is_better': 'Mai mare este mai bine',
  'assessments.aggregation.best': 'Cea mai bună încercare',
  'assessments.aggregation.mean': 'Media încercărilor valide',
  'assessments.aggregation.last': 'Ultima încercare validă',
  'assessments.aggregation.coach_selected': 'Încercarea aleasă de antrenor',
  'assessments.sessions.title': 'Sesiuni de evaluare',
  'assessments.sessions.empty': 'Încă nu există sesiuni.',
  'assessments.session.new': 'Sesiune nouă',
  'assessments.session.date': 'Data',
  'assessments.session.context': 'Context (opțional, doar pentru personal)',
  'assessments.session.protocols': 'Protocoale folosite',
  'assessments.session.athletes': 'Participanți',
  'assessments.session.search': 'Caută sportivi',
  'assessments.session.loadMore': 'Încarcă mai mulți',
  'assessments.session.team': 'Echipă',
  'assessments.session.group': 'Grup de antrenament',
  'assessments.session.rosterChoice': 'Adaugă o echipă sau un grup',
  'assessments.session.addRoster': 'Adaugă sportivii',
  'assessments.session.selected': 'selectați',
  'assessments.session.create': 'Creează sesiunea',
  'assessments.session.open': 'Deschide',
  'assessments.session.close': 'Închide',
  'assessments.session.participants': 'participanți',
  'assessments.session.drafts': 'ciorne',
  'assessments.session.published': 'publicate',
  'assessments.session.noProtocols': 'Adăugați mai întâi un protocol.',
  'assessments.session.noAthletes': 'Nu s-au găsit sportivi.',
  'assessments.entry.protocol': 'Protocol',
  'assessments.entry.athlete': 'Sportiv',
  'assessments.entry.attempt': 'Încercarea',
  'assessments.entry.invalid': 'Invalidă',
  'assessments.entry.blankHint':
    'Lăsați goală o încercare care nu a fost făcută. Zero este o valoare măsurată. Marcați o încercare greșită ca invalidă.',
  'assessments.entry.yes': 'Da',
  'assessments.entry.no': 'Nu',
  'assessments.entry.choose': 'Neînregistrat',
  'assessments.entry.level': 'Nivel',
  'assessments.entry.counts': 'Contează',
  'assessments.entry.selectedAttempt': 'Încercarea care contează',
  'assessments.entry.reason': 'Motivul alegerii',
  'assessments.entry.privateNote': 'Notă privată (doar antrenori)',
  'assessments.entry.publicComment': 'Comentariu pentru familii (vizibil după publicare)',
  'assessments.entry.save': 'Salvează rezultatele',
  'assessments.entry.unsaved': 'Modificări nesalvate',
  'assessments.entry.savedRows': 'rânduri salvate',
  'assessments.entry.conflict':
    'Un alt antrenor a modificat mai întâi acest rând. Se afișează intrarea lui; verificați-o și salvați din nou dacă este nevoie.',
  'assessments.entry.published': 'Publicat. Folosiți Corectează pentru a-l modifica.',
  'assessments.entry.publish': 'Publică ciornele',
  'assessments.entry.publishDone': 'publicate',
  'assessments.entry.correct': 'Corectează',
  'assessments.entry.correctionReason': 'Motivul corecturii',
  'assessments.entry.startCorrection': 'Începe corectura',
  'assessments.entry.cancelCorrection': 'Anulează',
  'assessments.entry.correctionDraft':
    'O corectură este în curs. Familiile văd în continuare rezultatul publicat până când o publicați.',
  'assessments.entry.discardCorrection': 'Renunță la corectură',
  'assessments.entry.draftState': 'Ciornă',
  'assessments.entry.publishedState': 'Publicat',
  'assessments.entry.noResult': 'Încă nu există rezultat',
  'assessments.status.valid': 'Validă',
  'assessments.status.invalid': 'Invalidă',
  'assessments.status.not_attempted': 'Neîncercată',
  'assessments.export.button': 'Exportă rezultatele',
  'assessments.export.column.familyName': 'Nume de familie',
  'assessments.export.column.givenName': 'Prenume',
  'assessments.export.column.protocol': 'Protocol',
  'assessments.export.column.protocolVersion': 'Versiunea protocolului',
  'assessments.export.column.unit': 'Unitate',
  'assessments.export.column.status': 'Stare',
  'assessments.export.column.value': 'Rezultat',
  'assessments.export.column.revision': 'Revizie',
  'assessments.export.column.publishedAt': 'Publicat',
  'assessments.export.column.comment': 'Comentariu pentru familii',
  'assessments.aggregates.title': 'Sinteza grupului (doar pentru personal)',
  'assessments.aggregates.count': 'Cu rezultat',
  'assessments.aggregates.suppressed':
    'Mai puțin de cinci participanți au un rezultat, de aceea nu se afișează cifre.',
  'assessments.aggregates.minimum': 'Cea mai mică',
  'assessments.aggregates.maximum': 'Cea mai mare',
  'assessments.aggregates.mean': 'Media',
  'assessments.progress.title': 'Progres',
  'assessments.progress.athlete': 'Sportiv',
  'assessments.progress.choose': 'Alegeți un sportiv',
  'assessments.progress.noAthletes': 'Nu există sportivi de afișat.',
  'assessments.progress.empty': 'Încă nu există rezultate publicate.',
  'assessments.progress.date': 'Data',
  'assessments.progress.value': 'Rezultat',
  'assessments.progress.version': 'Versiunea protocolului',
  'assessments.progress.comment': 'Comentariu',
  'assessments.progress.noValue': 'Nicio valoare validă',
  'assessments.progress.change': 'Schimbare față de primul rezultat',
  'assessments.progress.absolute': 'Diferența',
  'assessments.progress.percent': 'Îmbunătățire',
  'assessments.progress.calculation':
    'Acesta este un calcul despre măsurători, nu o apreciere a valorii sau a potențialului unui copil.',
  'assessments.progress.absoluteOnly': 'Pentru acest protocol se aplică doar diferența.',
  'assessments.progress.gapNote':
    'O întrerupere a liniei înseamnă că nu s-a înregistrat nicio valoare validă; nu este zero. Rezultatele se unesc doar când protocolul este același.',
  'assessments.progress.table': 'Rezultatele sub formă de tabel',
  'assessments.progress.chart': 'Graficul rezultatelor în timp',
  'assessments.progress.context': 'Înregistrat cu',
  'guardianLinks.adult.suspended':
    'Accesul tutorelui este suspendat deoarece sportivul a împlinit 18 ani la data de',
  'guardianLinks.adult.renew': 'Reînnoiește cu autorizarea sportivului',
  'guardianLinks.adult.renewedOn': 'Accesul a fost reînnoit cu autorizarea sportivului la data de',
  'guardianLinks.adult.title': 'Sportivi care împlinesc 18 ani',
  'guardianLinks.adult.intro':
    'La 18 ani accesul tutorelui este suspendat până când sportivul îl autorizează. Invitați sportivul să-și creeze propriul cont, apoi reînnoiți fiecare legătură după acordul său.',
  'guardianLinks.adult.on': 'Împlinește 18 ani la',
  'guardianLinks.adult.days': 'zile',
  'guardianLinks.adult.awaiting': 'Legături în așteptarea autorizării',
  'guardianLinks.adult.renewed': 'Reînnoite',
  'guardianLinks.adult.hasAccount': 'Are cont',
  'guardianLinks.adult.invite': 'Invită sportivul',
  'guardianLinks.edit.open': 'Editează',
  'guardianLinks.edit.save': 'Salvează modificările',
  'guardianLinks.edit.cancel': 'Anulează',
  'error.guardianLink.notAdult':
    'Sportivul nu a împlinit încă 18 ani, deci nu este nimic de autorizat.',
  'error.guardianLink.alreadyAuthorized':
    'Această legătură a fost deja reînnoită cu autorizarea sportivului.',
  'teams.rollover.title': 'Planificați sezonul următor',
  'teams.rollover.intro':
    'Aceasta creează un sezon nou, în stadiul de ciornă, cu copii ale echipelor și grupelor de antrenament pe care le păstrați. Sezonul pe care îl vizualizați și loturile sale rămân exact așa cum sunt.',
  'teams.rollover.open': 'Planificați sezonul următor',
  'teams.rollover.submit': 'Creați sezonul următor',
  'teams.rollover.cancel': 'Anulează',
  'teams.rollover.members': 'Membri activi',
  'teams.rollover.carryOver':
    'Repartizează și sportivii activi astăzi în noile echipe și grupe, de la începutul noului sezon',
  'teams.rollover.done': 'Creat',
  'teams.rollover.teamsCreated': 'echipe',
  'teams.rollover.groupsCreated': 'grupe',
  'teams.rollover.placementsCreated': 'repartizări',
  'athletes.status.archive': 'Arhivează sportivul',
  'athletes.status.withdraw': 'Înregistrează retragerea',
  'athletes.status.reactivate': 'Reactivează sportivul',
  'athletes.status.reason': 'Motiv',
  'athletes.status.hint.archive':
    'Arhivarea încheie astăzi calitatea de membru al clubului și repartizările pe echipe și grupe ale sportivului. Totul rămâne în istoric.',
  'athletes.status.hint.withdraw':
    'Retragerea face același lucru și încheie, după ziua de azi, accesul tutorilor la acest sportiv. Totul rămâne în istoric.',
  'athletes.status.done': 'Starea a fost modificată.',
  'athletes.status.ended.memberships': 'Calități de membru încheiate',
  'athletes.status.ended.teams': 'Repartizări pe echipe încheiate',
  'athletes.status.ended.groups': 'Repartizări pe grupe încheiate',
  'athletes.status.ended.links': 'Legături cu tutorii încheiate',
  'error.athlete.statusUnchanged': 'Sportivul are deja această stare.',
  'payments.title': 'Conturile dumneavoastră de facturare',
  'payments.note':
    'Fiecare cont este afișat separat. Sumele conturilor diferite nu se adună niciodată.',
  'payments.loading': 'Se încarcă conturile…',
  'payments.empty': 'Clubul nu a partajat încă niciun cont de facturare cu dumneavoastră.',
  'payments.statement.show': 'Afișează extrasul de cont',
  'payments.statement.hide': 'Ascunde extrasul de cont',
  'billing.accounts.title': 'Conturi de facturare',
  'billing.accounts.loading': 'Se încarcă conturile de facturare…',
  'billing.accounts.empty': 'Nu există încă niciun cont de facturare.',
  'billing.accounts.loadMore': 'Încarcă mai multe conturi',
  'billing.accounts.create.label': 'Numele contului',
  'billing.accounts.create.submit': 'Creează contul',
  'billing.accounts.open': 'Deschide contul',
  'billing.accounts.closed': 'Închis',
  'billing.back': 'Înapoi la conturi',
  'billing.detail.loading': 'Se încarcă contul…',
  'billing.position.balance': 'Sold',
  'billing.position.overdue': 'Restant',
  'billing.position.upcoming': 'Scadent în curând',
  'billing.position.credit': 'Credit nealocat',
  'billing.fees.plans.title': 'Planuri de taxe',
  'billing.fees.plans.empty': 'Încă nu există niciun plan de taxe.',
  'billing.fees.plans.create.title': 'Plan de taxe nou',
  'billing.fees.plans.create.titleVersion': 'Versiune nouă a planului selectat',
  'billing.fees.plan.name.en': 'Denumire (engleză)',
  'billing.fees.plan.name.hu': 'Denumire (maghiară, opțional)',
  'billing.fees.plan.name.ro': 'Denumire (română, opțional)',
  'billing.fees.plan.amount': 'Suma lunară',
  'billing.fees.plan.currency': 'Moneda',
  'billing.fees.plan.dueDay': 'Ziua scadenței în lună',
  'billing.fees.plan.dueDayHelp': 'O zi de după sfârșitul lunii cade în ultima zi a lunii.',
  'billing.fees.plan.effectiveFrom': 'În vigoare de la',
  'billing.fees.plan.effectiveTo': 'În vigoare până la (opțional)',
  'billing.fees.plan.version': 'Versiunea',
  'billing.fees.plan.newVersion': 'Versiune nouă',
  'billing.fees.plan.startNew': 'Creați în schimb un plan nou',
  'billing.fees.plan.submit': 'Salvează planul de taxe',
  'billing.fees.plan.saved': 'Planul de taxe a fost salvat.',
  'billing.fees.plan.invalid': 'Verificați suma, ziua scadenței și datele.',
  'billing.fees.run.title': 'Rularea lunară a taxelor',
  'billing.fees.run.month': 'Luna',
  'billing.fees.run.preview': 'Previzualizează rularea',
  'billing.fees.run.invalidMonth': 'Alegeți o lună.',
  'billing.fees.run.empty': 'Nicio taxă alocată nu atinge această lună.',
  'billing.fees.run.count.generate': 'Se vor înregistra',
  'billing.fees.run.count.review': 'Necesită verificare',
  'billing.fees.run.count.billed': 'Deja facturat',
  'billing.fees.run.count.skipped': 'Omis',
  'billing.fees.run.total': 'De înregistrat',
  'billing.fees.run.col.athlete': 'Sportiv',
  'billing.fees.run.col.account': 'Cont',
  'billing.fees.run.col.plan': 'Plan de taxe',
  'billing.fees.run.col.amount': 'Sumă',
  'billing.fees.run.col.due': 'Scadent',
  'billing.fees.run.col.status': 'Stare',
  'billing.fees.run.outcome.generate': 'Se va înregistra',
  'billing.fees.run.outcome.review': 'Necesită verificare',
  'billing.fees.run.outcome.billed': 'Deja facturat',
  'billing.fees.run.outcome.skip': 'Omis',
  'billing.fees.run.skip.notStarted': 'Nu a început încă',
  'billing.fees.run.skip.ended': 'Încheiat',
  'billing.fees.run.skip.paused': 'Suspendat',
  'billing.fees.run.skip.planNotEffective': 'Planul nu este în vigoare',
  'billing.fees.run.skip.fullyWaived': 'Scutit complet',
  'billing.fees.run.skip.accountClosed': 'Contul este închis',
  'billing.fees.run.skip.periodClosed': 'Perioada de raportare este închisă',
  'billing.fees.run.review.amount': 'Suma verificată',
  'billing.fees.run.review.help':
    'Acești sportivi încep la mijlocul lunii. Introduceți suma de taxat pentru prima lună sau lăsați câmpul gol pentru a nu înregistra nimic deocamdată.',
  'billing.fees.run.review.invalid': 'Introduceți o sumă validă.',
  'billing.fees.run.commit': 'Înregistrează rularea',
  'billing.fees.run.committed': 'Rularea a fost înregistrată.',
  'billing.fees.run.result.created': 'Taxe noi',
  'billing.fees.run.result.billed': 'Deja facturat',
  'billing.fees.run.result.review': 'În așteptarea verificării',
  'billing.fees.run.result.skipped': 'Omis',
  'billing.fees.auto.title': 'Rulare lunară automată',
  'billing.fees.auto.description':
    'Când este activată, sistemul înregistrează singur taxele lunii curente, după calendarul propriu al clubului. Înregistrează exact ce arată previzualizarea ca „Se vor înregistra”; alocările care încep la mijlocul lunii așteaptă verificarea dumneavoastră, iar o lună deja facturată nu se mai facturează niciodată.',
  'billing.fees.auto.on': 'Rularea automată este activată',
  'billing.fees.auto.off': 'Rularea automată este dezactivată',
  'billing.fees.auto.enable': 'Activează',
  'billing.fees.auto.disable': 'Dezactivează',
  'billing.fees.auto.confirm':
    'Previzualizați mai întâi luna curentă. După activare, sistemul poate înregistra taxele acestei luni în câteva minute. Activați rularea automată?',
  'billing.fees.auto.confirmEnable': 'Da, activează',
  'billing.fees.auto.cancel': 'Anulează',
  'billing.fees.auto.noRun': 'Nu a avut loc încă nicio rulare automată.',
  'billing.fees.auto.lastRun': 'Ultima rulare automată',
  'billing.fees.auto.succeeded': 'Reușită',
  'billing.fees.auto.failed': 'Eșuată, se reîncearcă automat',
  'billing.fees.assign.title': 'Planurile de taxă lunară ale contului',
  'billing.fees.assign.empty':
    'Acestui cont nu i-a fost atribuit niciun plan de taxă lunară. Cotizația anuală apare în secțiunea proprie de mai sus.',
  'billing.fees.assign.noPlans':
    'Clubul nu are niciun plan de taxă lunară. Aveți nevoie de unul doar pentru a percepe o taxă în fiecare lună; îl creați la Planuri de taxe și taxe lunare, pe pagina Finanțe.',
  'billing.fees.assign.athlete': 'Sportiv',
  'billing.fees.assign.plan': 'Plan de taxe',
  'billing.fees.assign.startsOn': 'Începe la',
  'billing.fees.assign.submit': 'Alocă taxa',
  'billing.fees.assign.end': 'Încheie',
  'billing.fees.assign.pause': 'Suspendă',
  'billing.fees.assign.resume': 'Reia',
  'billing.fees.assign.pausedFrom': 'Suspendare de la',
  'billing.fees.assign.pausedUntil': 'Suspendare până la (opțional)',
  'billing.fees.assign.pausedBadge': 'Suspendat',
  'billing.fees.concession.label': 'Reducere',
  'billing.fees.concession.none': 'Fără',
  'billing.fees.concession.amount': 'Reducere în sumă fixă',
  'billing.fees.concession.percent': 'Reducere procentuală',
  'billing.fees.concession.amountValue': 'Suma reducerii',
  'billing.fees.concession.percentValue': 'Reducere (%)',
  'billing.fees.concession.reason': 'Motivul aprobării',
  'billing.fees.concession.invalid': 'Introduceți o valoare validă și un motiv.',
  'billing.assignments.title': 'Sportivii din acest cont',
  'billing.assignments.empty': 'Niciun sportiv nu este atribuit acestui cont.',
  'billing.assignments.athleteSearch': 'Caută un sportiv',
  'billing.assignments.noMatches': 'Niciun sportiv nu corespunde.',
  'billing.assignments.assign': 'Atribuie sportivul',
  'billing.assignments.end': 'Încheie atribuirea',
  'billing.assignments.until': 'până la',
  'billing.access.title': 'Persoane cu acces la acest cont',
  'billing.access.empty': 'Nicio persoană nu este aprobată pentru acest cont.',
  'billing.access.personSearch': 'Caută o persoană',
  'billing.access.noMatches': 'Nicio persoană nu corespunde.',
  'billing.access.permission': 'Permisiune',
  'billing.access.permission.view': 'Vizualizare sold și extras',
  'billing.access.permission.manage': 'Gestionare',
  'billing.access.from': 'de la',
  'billing.access.validFrom': 'Valabil de la',
  'billing.access.validUntil': 'Valabil până la (opțional)',
  'billing.access.grant': 'Aprobă persoana',
  'billing.access.revoke': 'Revocă accesul',
  'billing.access.revoked': 'Revocat',
  'billing.charges.title': 'Taxe',
  'billing.charges.empty': 'Nu există încă taxe.',
  'billing.charges.post.title': 'Înregistrează o taxă',
  'billing.charges.post.description': 'Descriere',
  'billing.charges.post.amount': 'Suma',
  'billing.charges.post.dueOn': 'Data scadenței',
  'billing.charges.post.submit': 'Înregistrează taxa',
  'billing.charge.open': 'Deschisă',
  'billing.charge.paid': 'Achitată',
  'billing.charge.reversed': 'Stornată',
  'billing.charge.creditNote': 'Notă de credit',
  'billing.charge.reverse': 'Stornează taxa',
  'billing.kind.fee': 'Cotizație',
  'billing.kind.manual': 'Manuală',
  'billing.kind.opening': 'Sold inițial',
  'billing.col.description': 'Descriere',
  'billing.col.dueOn': 'Scadență',
  'billing.col.amount': 'Suma',
  'billing.col.outstanding': 'Rest de plată',
  'billing.col.status': 'Stare',
  'billing.col.date': 'Data',
  'billing.col.method': 'Metoda',
  'billing.col.reference': 'Referință',
  'billing.col.available': 'Disponibil',
  'billing.col.type': 'Tip',
  'billing.col.effectiveOn': 'În vigoare',
  'billing.col.change': 'Variație',
  'billing.col.balance': 'Sold',
  'billing.statement.title': 'Extras de cont',
  'billing.statement.asOf': 'Extras la data de',
  'billing.statement.loading': 'Se încarcă extrasul…',
  'billing.statement.empty': 'Până la această zi nu s-a înregistrat nimic pe acest cont.',
  'billing.statement.opening': 'Sold reportat',
  'billing.statement.closing': 'Sold la această dată',
  'billing.statement.truncated': 'Înregistrările mai vechi sunt incluse în soldul reportat.',
  'billing.statement.note':
    'Înregistrările contează din momentul în care au fost făcute. O variație pozitivă mărește suma datorată, una negativă o reduce. Restanța, sumele scadente în curând și creditul sunt cele din ziua aleasă.',
  'billing.statement.openCharges': 'Taxe încă de plătit în această zi',
  'billing.statement.kind.charge': 'Taxă',
  'billing.statement.kind.creditNote': 'Notă de credit',
  'billing.statement.kind.payment': 'Plată',
  'billing.statement.kind.paymentReversal': 'Plată stornată',
  'billing.statement.kind.refund': 'Rambursare',
  'billing.periods.title': 'Perioade închise',
  'billing.periods.note':
    'Închiderea unei perioade blochează registrul până la o zi: după aceea nu se mai poate înregistra, nici manual, nici prin generarea taxelor, o taxă cu scadența sau o plată din ziua respectivă ori dinaintea ei. Închiderea nu poate fi anulată. Corecturile ulterioare se înregistrează ca note de credit, stornări sau rambursări în perioada deschisă.',
  'billing.periods.closedThrough': 'Închis până la',
  'billing.periods.none': 'Nicio perioadă nu a fost încă închisă.',
  'billing.periods.field.closedThrough': 'Închidere până la (inclusiv)',
  'billing.periods.field.note': 'Motiv sau observație',
  'billing.periods.field.confirm': 'Înțeleg că aceasta nu poate fi anulată',
  'billing.periods.submit': 'Închide perioada',
  'billing.periods.done': 'Perioada a fost închisă.',
  'billing.periods.history': 'Închideri anterioare',
  'billing.periods.closedAt': 'Închis la',
  'billing.reports.title': 'Rapoarte',
  'billing.reports.note':
    'Totalurile întregului club așa cum arăta registrul la sfârșitul zilei alese, un bloc pe monedă; monedele diferite nu se adună niciodată. Restant este ce se mai datorează din taxele cu scadența înainte de acea zi. Taxele sunt grupate după echipa în care se afla sportivul la data scadenței, iar plățile după metodă.',
  'billing.reports.asOf': 'Raport la data',
  'billing.reports.asOfHelp': 'Lăsat gol: azi.',
  'billing.reports.season': 'Sezon',
  'billing.reports.team': 'Echipa la data scadenței',
  'billing.reports.method': 'Metodă de plată',
  'billing.reports.account': 'Cont',
  'billing.reports.any': 'Toate',
  'billing.reports.loading': 'Se încarcă raportul…',
  'billing.reports.empty': 'Nu există conturi de facturare pentru această selecție.',
  'billing.reports.accounts': 'Conturi',
  'billing.reports.generatedAt': 'Generat',
  'billing.reports.currency': 'Monedă',
  'billing.reports.byTeam': 'Taxe pe echipe la data scadenței',
  'billing.reports.byMethod': 'Plăți pe metode',
  'billing.reports.noTeam': 'Fără echipă la data scadenței',
  'billing.reports.total': 'Total',
  'billing.reports.col.team': 'Echipa',
  'billing.reports.col.method': 'Metoda',
  'billing.reports.col.count': 'Înregistrări',
  'billing.reports.col.charged': 'Facturat',
  'billing.reports.col.credited': 'Note de credit',
  'billing.reports.col.allocated': 'Alocat',
  'billing.reports.col.received': 'Încasat',
  'billing.reports.col.reversed': 'Anulat',
  'billing.reports.col.refunded': 'Rambursat',
  'billing.reports.chargesOmitted':
    'Taxele nu sunt afișate cât timp este aleasă o metodă de plată, pentru că o taxă nu are metodă de plată.',
  'billing.reports.paymentsOmitted':
    'Plățile nu sunt afișate cât timp este aleasă o echipă, pentru că o plată aparține unui cont, nu unei echipe.',
  'billing.reports.reconciliation.title': 'Reconciliere',
  'billing.reports.reconciliation.note':
    'Compară vederile de taxe, plăți, alocări, rambursări și extras ale aceluiași registru. Cuprinde toate înregistrările conturilor alese până la această zi, indiferent ce sezon, echipă sau metodă este aleasă.',
  'billing.reports.reconciliation.check': 'Verificare',
  'billing.reports.reconciliation.expected': 'Așteptat',
  'billing.reports.reconciliation.actual': 'Găsit',
  'billing.reports.reconciliation.result': 'Rezultat',
  'billing.reports.reconciliation.ok': 'Concordă',
  'billing.reports.reconciliation.mismatch': 'Diferă',
  'billing.reports.check.balance':
    'Soldul din taxe și plăți este egal cu suma înregistrărilor din extras',
  'billing.reports.check.settle':
    'Ce se datorează din taxe este egal cu totalul rămas de plată (nicio taxă nu este achitată peste valoarea ei)',
  'billing.reports.check.allocations':
    'Alocările văzute din taxe sunt egale cu alocările văzute din plăți',
  'billing.reports.check.payments':
    'Plățile păstrate sunt egale cu suma alocată, rambursată și a creditului nealocat',
  'billing.reports.export': 'Descarcă CSV',
  'billing.reason': 'Motiv',
  'billing.confirm': 'Confirmă',
  'billing.cancel': 'Anulează',
  'billing.creditNote.amount': 'Suma creditului',
  'billing.creditNote.submit': 'Înregistrează nota de credit',
  'billing.reverse.submit': 'Stornează',
  'billing.refund.amount': 'Suma rambursării',
  'billing.refund.submit': 'Înregistrează rambursarea',
  'billing.payments.title': 'Plăți',
  'billing.payments.empty': 'Nu există încă plăți.',
  'billing.payment.post.title': 'Înregistrează o plată',
  'billing.payment.amount': 'Suma primită',
  'billing.payment.paidOn': 'Data primirii',
  'billing.payment.method': 'Metoda',
  'billing.payment.reference': 'Chitanță sau referință bancară',
  'billing.payment.payerReference': 'Plătitor (opțional)',
  'billing.payment.preview': 'Previzualizează alocarea',
  'billing.payment.allocation.title':
    'Alocare, începând cu cea mai veche scadență. Modificați sumele dacă este nevoie.',
  'billing.payment.allocation.none':
    'Contul nu are nicio taxă deschisă. Întreaga sumă rămâne credit nealocat.',
  'billing.payment.allocation.invalidAmount':
    'Introduceți fiecare sumă alocată ca număr pozitiv cu cel mult două zecimale sau lăsați-o goală.',
  'billing.payment.allocation.exceedsPayment': 'Sumele alocate depășesc împreună plata.',
  'billing.payment.allocation.total': 'Alocat',
  'billing.payment.allocation.unallocated': 'Rămâne credit nealocat',
  'billing.payment.submit': 'Înregistrează plata',
  'billing.payment.reversed': 'Stornată',
  'billing.payment.refunded': 'Rambursată',
  'billing.payment.reverse': 'Stornează plata',
  'billing.payment.refund': 'Rambursează',
  'billing.payment.allocate': 'Alocă creditul',
  'billing.payment.allocate.submit': 'Alocă',
  'billing.payment.allocate.nothingOpen':
    'Contul nu are nicio taxă deschisă căreia să i se poată aloca creditul.',
  'billing.method.cash': 'Numerar',
  'billing.method.bankTransfer': 'Transfer bancar',
  'billing.method.cardTerminal': 'Terminal de card',
  'billing.method.openingBalance': 'Sold inițial',
  'billing.method.other': 'Altele',
  'billing.invalidAmount':
    'Introduceți o sumă pozitivă cu cel mult două zecimale, de exemplu 200,50.',
  'billing.posted': 'Înregistrat.',
  'teams.category.U7': 'U7',
  'teams.category.U9': 'U9',
  'teams.category.WOMEN': 'Senioare',
  'teams.category.GIRLS_3X3_CUP': 'Cupa 3x3 fete',
  'competitions.seasons.title': 'Sezoane de competiție',
  'competitions.seasons.empty': 'Nu a fost creat încă niciun sezon de competiție.',
  'competitions.seasons.create.title': 'Sezon de competiție nou',
  'competitions.seasons.submit': 'Creează sezonul de competiție',
  'competitions.seasons.done': 'Sezonul de competiție a fost creat.',
  'competitions.field.season': 'Sezon',
  'competitions.field.name': 'Nume',
  'competitions.field.federation': 'Federație',
  'competitions.field.category': 'Categorie',
  'competitions.field.division': 'Divizie (opțional)',
  'competitions.field.format': 'Format (opțional)',
  'competitions.field.phases': 'Faze',
  'competitions.phase.regular': 'Sezon regulat',
  'competitions.phase.playoff': 'Play-off',
  'competitions.phase.tournament': 'Turneu',
  'competitions.rules.none':
    'Nicio versiune de reguli activă: eligibilitatea rămâne „necesită verificare”.',
  'competitions.rules.active': 'Versiune de reguli activă',
  'competitions.profiles.title': 'Versiuni ale profilului de reguli',
  'competitions.profiles.empty':
    'Această competiție nu are încă profil de reguli. Până la activarea unuia, orice rezultat de eligibilitate este „necesită verificare”.',
  'competitions.profiles.catalogField': 'Pornește o schiță din',
  'competitions.profiles.createDraft': 'Creează schița',
  'competitions.profiles.draftCreated': 'Schița a fost creată.',
  'competitions.profile.version': 'Versiunea',
  'competitions.profile.status.draft': 'Schiță',
  'competitions.profile.status.active': 'Activă',
  'competitions.profile.status.superseded': 'Înlocuită',
  'competitions.profile.validity': 'Valabilă',
  'competitions.profile.counts':
    'surse: {sources}, hash-uri înregistrate: {hashes}, condiții: {conditions}, verificări manuale: {manual}',
  'competitions.profile.checkedOn': 'Surse verificate la',
  'competitions.profile.activatedOn': 'Activată la',
  'competitions.profile.draftNote':
    'O schiță nu aprobă niciodată pe nimeni. Înregistrați verificarea documentelor sursă, apoi activați-o.',
  'competitions.profile.manualChecks':
    'Verificări manuale obligatorii (necodificate; rămân deschise și blochează un export gata pentru uz oficial)',
  'competitions.verify.title': 'Înregistrați verificarea surselor',
  'competitions.verify.hashField': 'SHA-256 al sursei',
  'competitions.verify.checkedOn': 'Ziua în care ați verificat sursele',
  'competitions.verify.note': 'Ce ați verificat (modificări, competiția clubului)',
  'competitions.verify.submit': 'Înregistrează verificarea surselor',
  'competitions.verify.done': 'Verificarea surselor a fost înregistrată.',
  'competitions.verify.problem.hash': 'Un hash are 64 de caractere hexazecimale.',
  'competitions.verify.problem.date': 'Introduceți o dată validă.',
  'competitions.verify.problem.future': 'Data verificării nu poate fi în viitor.',
  'competitions.verify.problem.note': 'Scrieți ce ați verificat.',
  'competitions.activate.title': 'Activați această versiune',
  'competitions.activate.note': 'Motivul activării',
  'competitions.activate.confirm':
    'Am verificat documentele sursă exacte și competiția clubului în raport cu această versiune.',
  'competitions.activate.submit': 'Activează versiunea',
  'competitions.activate.done':
    'Versiunea a fost activată. Versiunea activă anterioară a fost înlocuită.',
  'competitions.blocker.no_sources':
    'Profilul nu numește nicio sursă, deci nu are ce fi verificat și nu poate fi activat.',
  'competitions.blocker.source_hash_missing': 'Înregistrați SHA-256 pentru fiecare document sursă.',
  'competitions.blocker.sources_not_checked':
    'Înregistrați ziua în care ați verificat sursele pentru modificări.',
  'competitions.blocker.category_mismatch': 'Categoria profilului diferă de categoria competiției.',
  'error.competition.invalidTimeZone': 'Acesta nu este un fus orar cunoscut.',
  'error.competition.seasonClosed': 'Sezonul este închis; nu i se pot adăuga competiții.',
  'error.ruleProfile.unknownCatalogKey': 'Această schiță nu este în catalog.',
  'error.ruleProfile.categoryMismatch': 'Schița aparține altei categorii decât competiția.',
  'error.ruleProfile.draftExists':
    'Această competiție are deja o schiță; verificați-o și activați-o mai întâi.',
  'error.ruleProfile.notDraft': 'Doar o schiță poate fi modificată.',
  'error.ruleProfile.unknownSource':
    'S-a dat un hash pentru o sursă pe care profilul nu o numește.',
  'error.ruleProfile.checkedInFuture': 'Data verificării nu poate fi în viitor.',
  'error.ruleProfile.notReady':
    'Înainte de activare înregistrați hash-ul fiecărei surse și data verificării.',
  'registrations.title': 'Înregistrări',
  'registrations.loading': 'Se încarcă înregistrările…',
  'registrations.empty': 'Niciun sportiv nu este încă înregistrat în această competiție.',
  'registrations.openEnded': 'fără ultimă zi',
  'registrations.license': 'Referință de licență',
  'registrations.endedReason': 'Motivul încheierii',
  'registrations.mode.native': 'Nativ',
  'registrations.mode.temporary_play_up': 'Promovare temporară',
  'registrations.mode.exclusive_higher': 'Exclusiv categoria superioară',
  'registrations.mode.hint':
    'Nativ: sportivul joacă în propria categorie. Promovare temporară: sportivul joacă la categoria superioară pentru o perioadă limitată. Exclusiv superior: sportivul este înregistrat doar la categoria superioară.',
  'registrations.status.active': 'Activă',
  'registrations.status.ended': 'Încheiată',
  'registrations.create.title': 'Înregistrează un sportiv',
  'registrations.field.athlete': 'Sportiv (scrieți un nume)',
  'registrations.field.team': 'Echipă',
  'registrations.field.mode': 'Mod de înregistrare',
  'registrations.field.validFrom': 'Prima zi',
  'registrations.field.validTo': 'Ultima zi (opțional)',
  'registrations.field.license': 'Referință de licență (opțional)',
  'registrations.field.classification': 'Clasificare în competiție',
  'registrations.classification.hint':
    'Doar ce cer regulile acestei competiții: fete pentru intervalul de naștere al fetelor, jucătoare de lot național pentru jucătoarele care au nevoie de aprobarea comisiei de competiție, general pentru toți ceilalți.',
  'registrations.classification.general': 'General',
  'registrations.classification.girls': 'Fete',
  'registrations.classification.national_team_female': 'Jucătoare de lot național',
  'registrations.noAthletes': 'Niciun rezultat',
  'registrations.noTeams':
    'Departamentul acestei competiții nu are încă nicio echipă în acest sezon. Creați mai întâi una în pagina Echipe.',
  'registrations.submit': 'Înregistrează sportivul',
  'registrations.done': 'Sportiv înregistrat.',
  'registrations.correct': 'Corectare',
  'registrations.correct.submit': 'Salvează corectarea',
  'registrations.correct.done': 'Înregistrare corectată.',
  'registrations.end': 'Încheie înregistrarea',
  'registrations.end.hint':
    'Înregistrarea rămâne ca istoric. Pentru a înregistra din nou sportivul, creați o înregistrare nouă.',
  'registrations.end.day': 'Ultima zi a înregistrării',
  'registrations.end.reason': 'Motivul încheierii',
  'registrations.end.submit': 'Încheie înregistrarea',
  'registrations.end.done': 'Înregistrare încheiată.',
  'registrations.cancel': 'Anulează',
  'error.registration.overlap':
    'Acest sportiv are deja o înregistrare activă în această competiție în unele dintre aceste zile.',
  'error.registration.athleteNotActive': 'Poate fi înregistrat doar un sportiv activ.',
  'error.registration.teamMismatch':
    'Alegeți o echipă activă din departamentul și sezonul acestei competiții.',
  'error.registration.notActive':
    'Această înregistrare s-a încheiat și nu mai poate fi modificată.',
  'error.registration.invalidEnd':
    'Ultima zi nu poate fi înaintea primei zile, în viitor sau după ultima zi planificată.',
  'error.registration.invalidValidTo': 'Ultima zi nu poate fi înaintea primei zile.',
  'evidence.title': 'Documente justificative',
  'evidence.hint':
    'Notează că există un document pentru un sportiv, cine l-a emis și zilele în care este valabil, apoi aprobă-l sau respinge-l. Doar dovezile aprobate contează pentru eligibilitate. Copia documentului nu este păstrată aici.',
  'evidence.loading': 'Se încarcă dovezile…',
  'evidence.empty': 'Pentru sportivii acestei competiții nu este notată încă nicio dovadă.',
  'evidence.openEnded': 'fără ultimă zi',
  'evidence.issuer': 'Emitent',
  'evidence.reference': 'Referință',
  'evidence.decisionNote': 'Notă la decizie',
  'evidence.type.medical_clearance': 'Aviz medical',
  'evidence.type.under_18_agreement': 'Acord pentru sportiv sub 18 ani',
  'evidence.type.promotion_agreement': 'Acord de promovare',
  'evidence.type.loan_agreement': 'Acord de împrumut',
  'evidence.type.transfer_approval': 'Aprobare de transfer',
  'evidence.status.pending': 'Așteaptă decizia',
  'evidence.status.verified': 'Aprobat',
  'evidence.status.rejected': 'Respins',
  'evidence.create.title': 'Notează o dovadă',
  'evidence.field.athlete': 'Sportiv (scrie un nume)',
  'evidence.field.type': 'Tipul documentului',
  'evidence.field.issuer': 'Emitent (opțional)',
  'evidence.field.reference': 'Referință (opțional)',
  'evidence.field.validFrom': 'Prima zi de valabilitate',
  'evidence.field.validTo': 'Ultima zi de valabilitate (opțional)',
  'evidence.noAthletes': 'Niciun sportiv găsit',
  'evidence.submit': 'Notează dovada',
  'evidence.done': 'Dovada a fost notată. Contează după aprobare.',
  'evidence.correct': 'Corectare',
  'evidence.correct.submit': 'Salvează corectarea',
  'evidence.correct.done': 'Dovada a fost corectată.',
  'evidence.verify': 'Aprobă',
  'evidence.verify.hint':
    'Confirmă că ai văzut documentul și că datele se potrivesc. O înregistrare aprobată nu mai poate fi corectată, doar retrasă.',
  'evidence.verify.note': 'Notă (opțional, nu scrie detalii medicale)',
  'evidence.verify.submit': 'Aprobă dovada',
  'evidence.verify.done': 'Dovada a fost aprobată.',
  'evidence.reject': 'Respinge',
  'evidence.withdraw': 'Retrage',
  'evidence.reject.hint':
    'Înregistrarea rămâne ca istoric și nu mai poate fi schimbată. Dacă există un document valabil, notează-l ca dovadă nouă.',
  'evidence.reject.reason': 'Motiv (nu scrie detalii medicale)',
  'evidence.reject.submit': 'Confirmă',
  'evidence.reject.done': 'Dovada a fost respinsă.',
  'evidence.cancel': 'Anulează',
  'error.evidence.wrongState':
    'Pentru această dovadă s-a decis deja sau a fost retrasă, deci nu mai poate fi modificată astfel.',
  'error.evidence.invalidInterval': 'Ultima zi de valabilitate nu poate fi înaintea primei zile.',
  'suspension.title': 'Suspendări',
  'suspension.hint':
    'Înregistrează că un sportiv nu are voie să joace până la o ultimă zi sau pentru un număr de meciuri. Doar o suspendare activă contează pentru eligibilitate; una executată sau revocată rămâne ca istoric.',
  'suspension.loading': 'Se încarcă suspendările…',
  'suspension.empty': 'Nicio suspendare nu se aplică acestei competiții.',
  'suspension.until': 'până la',
  'suspension.gamesLeft': 'meciuri rămase',
  'suspension.everyCompetition': 'toate competițiile clubului',
  'suspension.reference': 'Referința deciziei',
  'suspension.closingNote': 'Notă la închidere',
  'suspension.status.active': 'Activă',
  'suspension.status.served': 'Executată',
  'suspension.status.revoked': 'Revocată',
  'suspension.create.title': 'Înregistrează o suspendare',
  'suspension.field.athlete': 'Sportiv (scrie un nume)',
  'suspension.field.scope': 'Se aplică în',
  'suspension.field.measure': 'Numărată în',
  'suspension.measure.games': 'Meciuri',
  'suspension.measure.days': 'Zile (până la o ultimă zi)',
  'suspension.field.startsOn': 'Prima zi',
  'suspension.field.endsOn': 'Ultima zi',
  'suspension.field.games': 'Meciuri rămase',
  'suspension.field.gamesHint': 'Un număr întreg de la 0 la {maximum}.',
  'suspension.field.reference': 'Referința deciziei (opțional)',
  'suspension.noAthletes': 'Niciun sportiv găsit',
  'suspension.submit': 'Înregistrează suspendarea',
  'suspension.done': 'Suspendarea a fost înregistrată. Contează cât timp este activă.',
  'suspension.correct': 'Corectează',
  'suspension.correct.submit': 'Salvează corecția',
  'suspension.correct.done': 'Suspendarea a fost corectată.',
  'suspension.serve': 'Marchează executată',
  'suspension.serve.hint':
    'Confirmă că suspendarea a fost executată. Rămâne ca istoric și nu mai contează.',
  'suspension.serve.note': 'Notă (opțional)',
  'suspension.serve.submit': 'Marchează executată',
  'suspension.serve.done': 'Suspendarea a fost marcată ca executată.',
  'suspension.revoke': 'Revocă',
  'suspension.revoke.hint':
    'Suspendarea rămâne ca istoric, nu mai contează și nu se mai poate schimba. Folosește această opțiune când decizia a fost anulată sau a fost înregistrată din greșeală.',
  'suspension.revoke.reason': 'Motiv',
  'suspension.revoke.submit': 'Confirmă',
  'suspension.revoke.done': 'Suspendarea a fost revocată.',
  'suspension.cancel': 'Anulează',
  'error.suspension.wrongState':
    'Această suspendare a fost deja executată sau revocată și nu mai poate fi schimbată astfel.',
  'error.suspension.invalidInterval': 'Ultima zi nu poate fi înaintea primei zile.',
  'error.suspension.wrongMeasure':
    'O suspendare numărată în zile nu poate primi un număr de meciuri, și invers.',
  'match.title': 'Meciuri',
  'match.hint':
    'Atașează competiției un eveniment de tip meci al departamentului, cu echipa clubului, o fază și adversarul. Încheierea înregistrează versiunea de reguli activă; un meci încheiat sau anulat rămâne ca istoric.',
  'match.loading': 'Se încarcă meciurile…',
  'match.empty': 'Pentru această competiție nu este înregistrat niciun meci.',
  'match.status.scheduled': 'Programat',
  'match.status.completed': 'Încheiat',
  'match.status.cancelled': 'Anulat',
  'match.homeAway.home': 'Gazdă',
  'match.homeAway.away': 'Oaspete',
  'match.eventCancelled':
    'Evenimentul din calendar al acestui meci a fost anulat; meciul nu poate fi încheiat.',
  'match.ruleVersion': 'Versiunea de reguli folosită',
  'match.noRuleVersion': 'La încheiere nu era activă nicio versiune de reguli.',
  'match.cancelReason': 'Motiv',
  'match.create.title': 'Înregistrează un meci',
  'match.field.event': 'Eveniment de meci',
  'match.field.team': 'Echipă',
  'match.field.phase': 'Fază',
  'match.field.opponent': 'Adversar',
  'match.field.opponentHint': 'Numele unui club, cel mult 100 de caractere.',
  'match.field.homeAway': 'Gazdă sau oaspete',
  'match.noEvents':
    'Nu există niciun eveniment de meci liber în acest sezon. Creează mai întâi un eveniment de meci în Calendar.',
  'match.noTeams': 'Nu există nicio echipă activă a acestui departament și sezon.',
  'match.submit': 'Înregistrează meciul',
  'match.done': 'Meci înregistrat.',
  'match.correct': 'Corectează',
  'match.correct.submit': 'Salvează corecția',
  'match.correct.done': 'Meci corectat.',
  'match.complete': 'Marchează ca încheiat',
  'match.complete.hint':
    'Confirmă că meciul s-a jucat. Versiunea de reguli activă acum se înregistrează la meci, iar meciul nu se mai poate schimba.',
  'match.complete.submit': 'Marchează ca încheiat',
  'match.complete.done': 'Meciul a fost marcat ca încheiat.',
  'match.cancel': 'Anulează meciul',
  'match.cancel.hint':
    'Meciul rămâne ca istoric și nu se mai poate schimba. Evenimentul lui devine liber pentru un alt meci.',
  'match.cancel.reason': 'Motiv',
  'match.cancel.submit': 'Confirmă',
  'match.cancel.done': 'Meci anulat.',
  'match.close': 'Închide',
  'error.match.wrongState':
    'Acest meci a fost deja încheiat sau anulat și nu mai poate fi modificat astfel.',
  'error.match.eventTaken': 'Acest eveniment este deja folosit de un alt meci.',
  'error.match.invalidEvent': 'Alege un eveniment de meci neanulat al departamentului.',
  'error.match.invalidTeam':
    'Echipa trebuie să fie o echipă activă a departamentului și sezonului competiției.',
  'error.match.invalidPhase': 'Faza trebuie să fie una dintre fazele competiției.',
  'error.match.notPlayedYet':
    'Ziua acestui meci nu a venit încă, deci nu poate fi marcat ca încheiat.',
  'error.match.eventCancelled':
    'Evenimentul din calendar al acestui meci a fost anulat, deci meciul nu poate fi încheiat.',
  'roster.open': 'Lot',
  'roster.title': 'Lot',
  'roster.hint':
    'Sportivii selectați pentru acest meci. Selecția nu verifică eligibilitatea (folosește Verifică eligibilitatea mai jos) și nu dovedește că sportivul a jucat.',
  'roster.loading': 'Se încarcă lotul…',
  'roster.empty': 'Pentru acest meci nu este selectat încă niciun sportiv.',
  'roster.locked': 'Acest meci nu mai este programat, deci lotul său nu se mai poate modifica.',
  'roster.role.goalkeeper': 'Portar',
  'roster.role.defender': 'Fundaș',
  'roster.role.forward': 'Atacant',
  'roster.noShirt': 'fără număr',
  'roster.shirt': 'Tricou',
  'roster.field.athlete': 'Sportiv',
  'roster.field.role': 'Rol în acest meci',
  'roster.field.shirt': 'Număr de tricou (0–99)',
  'roster.noAthletes': 'Niciun sportiv nu se potrivește.',
  'roster.add': 'Adaugă în lot',
  'roster.add.done': 'Sportivul a fost adăugat în lot.',
  'roster.edit': 'Modifică',
  'roster.edit.submit': 'Salvează',
  'roster.edit.done': 'Intrarea din lot a fost salvată.',
  'roster.remove': 'Elimină',
  'roster.remove.done': 'Sportivul a fost eliminat din lot.',
  'roster.close': 'Închide',
  'roster.status.draft': 'Ciornă',
  'roster.status.finalized': 'Finalizat',
  'roster.finalizedAt': 'Finalizat: {finalizedAt}.',
  'roster.acknowledged': 'La finalizare au fost luate la cunoștință elementele încă în verificare.',
  'roster.frozen':
    'Acest lot este finalizat. Redeschide-l ca să îl modifici sau ca să verifici din nou eligibilitatea.',
  'roster.finalize': 'Finalizează lotul',
  'roster.finalize.hint':
    'Mai întâi fiecare sportiv este verificat din nou. Finalizarea este refuzată dacă un sportiv nu este eligibil sau lotul încalcă o regulă.',
  'roster.finalize.acknowledgement': 'Declarație despre ce mai necesită verificare',
  'roster.finalize.acknowledgement.help':
    'Este necesară când ceva din lot mai necesită verificare. Spune că ai verificat și cum.',
  'roster.finalize.submit': 'Finalizează',
  'roster.finalize.done': 'Lotul a fost finalizat.',
  'roster.reopen': 'Redeschide lotul',
  'roster.reopen.reason': 'Motivul redeschiderii',
  'roster.reopen.submit': 'Redeschide',
  'roster.reopen.done': 'Lotul a fost redeschis ca ciornă.',
  'manualCheck.hint':
    'Înregistrează o verificare ca făcută doar după ce ai făcut-o tu; o verificare înregistrată este valabilă doar pentru acest lot și această versiune de reguli.',
  'manualCheck.open': 'deschisă',
  'manualCheck.done': 'făcută, verificată la {checkedOn}',
  'manualCheck.record': 'Înregistrează ca făcută',
  'manualCheck.record.submit': 'Înregistrează',
  'manualCheck.statement': 'Ce ai verificat',
  'manualCheck.statement.hint': 'Nu scrie date de sănătate sau alte date personale.',
  'manualCheck.checkedOn': 'Ziua verificării',
  'manualCheck.withdraw': 'Retrage înregistrarea',
  'manualCheck.withdraw.reason': 'Motivul retragerii',
  'manualCheck.withdraw.submit': 'Retrage',
  'manualCheck.close': 'Renunță',
  'error.manualCheck.alreadyRecorded':
    'Această verificare este deja înregistrată pentru acest lot și această versiune de reguli.',
  'error.manualCheck.notRecorded':
    'Această verificare nu este înregistrată, deci nu e nimic de retras.',
  'error.manualCheck.noActiveRules':
    'Competiția nu are o versiune de reguli activă, deci nu se poate înregistra nicio verificare.',
  'error.manualCheck.futureDay': 'Ziua verificării nu poate fi în viitor.',
  'externalHistory.title': 'Meciuri în afara clubului',
  'externalHistory.hint':
    'Meciurile verificate pe care un sportiv le-a jucat în afara loturilor acestui club se iau în calcul la limitele zilnice și săptămânale. Înregistrează fiecare meci, apoi atestă că istoricul este complet; fără atestare, sportivul rămâne la „Necesită verificare” oriunde regulile limitează numărul de meciuri.',
  'externalHistory.field.athlete': 'Sportiv (scrie un nume)',
  'externalHistory.noAthletes': 'Niciun sportiv găsit',
  'externalHistory.loading': 'Se încarcă…',
  'externalHistory.appearances.title': 'Meciuri jucate în afara clubului',
  'externalHistory.appearances.empty':
    'Pentru acest sportiv nu este înregistrat niciun meci în afara clubului.',
  'externalHistory.appearance.status.recorded': 'Înregistrat',
  'externalHistory.appearance.status.withdrawn': 'Retras',
  'externalHistory.appearance.source': 'Verificat la',
  'externalHistory.appearance.create.title': 'Înregistrează un meci jucat în afara clubului',
  'externalHistory.appearance.field.playedOn': 'Ziua jocului',
  'externalHistory.appearance.field.competition': 'Competiția sau clubul',
  'externalHistory.appearance.field.source': 'Unde a fost verificat',
  'externalHistory.appearance.field.sourceHint':
    'De exemplu numărul foii de meci sau o pagină a federației. Nu scrie date personale.',
  'externalHistory.appearance.submit': 'Înregistrează meciul',
  'externalHistory.appearance.done':
    'Meciul a fost înregistrat. Se ia în calcul la limitele zilnice și săptămânale.',
  'externalHistory.attestations.title': 'Atestări de completitudine',
  'externalHistory.attestations.empty': 'Pentru acest sportiv nu este înregistrată nicio atestare.',
  'externalHistory.attestation.status.granted': 'Acordată',
  'externalHistory.attestation.status.withdrawn': 'Retrasă',
  'externalHistory.attestation.covers': 'Complet din {from} până în {through}',
  'externalHistory.attestation.create.title': 'Atestă că istoricul este complet',
  'externalHistory.attestation.hint':
    'Declari că toate meciurile verificate jucate de acest sportiv în afara clubului în aceste zile sunt înregistrate mai sus. Pentru un meci contează doar dacă se întinde înapoi peste cea mai lungă fereastră de limitare a regulilor și ajunge până în ziua dinaintea meciului.',
  'externalHistory.attestation.field.from': 'Complet din',
  'externalHistory.attestation.field.through': 'Complet până în (nu în viitor)',
  'externalHistory.attestation.field.statement': 'Ce ai verificat',
  'externalHistory.attestation.submit': 'Atestă completitudinea',
  'externalHistory.attestation.done': 'Atestarea a fost înregistrată.',
  'externalHistory.withdraw': 'Retrage',
  'externalHistory.withdraw.reason': 'Motivul retragerii',
  'externalHistory.withdraw.submit': 'Confirmă retragerea',
  'externalHistory.withdraw.done': 'Înregistrarea a fost retrasă.',
  'externalHistory.withdrawnReason': 'Motivul retragerii',
  'externalHistory.cancel': 'Renunță',
  'error.externalHistory.futureDay': 'Ziua nu poate fi în viitor.',
  'error.externalHistory.wrongState':
    'Această înregistrare a fost deja retrasă și nu mai poate fi modificată.',
  'roster.export': 'Exportă lotul (CSV)',
  'roster.export.hint':
    'Descarcă acest lot pentru uz intern. Este un instrument intern și nu este niciodată o depunere la federație.',
  'roster.export.ready':
    'Gata oficial: toate verificările au trecut. Fișierul rămâne un instrument intern, nu o depunere.',
  'roster.export.blocked': 'Nu este gata oficial, deci fișierul este o ciornă. Motive:',
  'roster.export.hidden': 'Încă {count} sportivi din afara domeniului tău nu sunt în fișier.',
  'roster.export.blocker.PROFILE_NOT_ACTIVE': 'Competiția nu are o versiune de reguli activă.',
  'roster.export.blocker.ROSTER_NOT_FINALIZED': 'Lotul nu este finalizat.',
  'roster.export.blocker.ENTRIES_NOT_VISIBLE':
    'Unii sportivi din lot sunt în afara domeniului tău, deci fișierul nu poate lista lotul integral.',
  'roster.export.blocker.ROSTER_NOT_ELIGIBLE':
    'Un sportiv sau lotul în ansamblu nu este eligibil ori necesită încă verificare.',
  'roster.export.blocker.MANUAL_CHECK_UNRESOLVED':
    'Verificarea manuală „{key}” nu este înregistrată ca făcută.',
  'roster.export.file.label': 'Instrument intern, nu o depunere oficială',
  'roster.export.file.competition': 'Competiție',
  'roster.export.file.opponent': 'Adversar',
  'roster.export.file.matchDay': 'Ziua meciului',
  'roster.export.file.status': 'Starea lotului',
  'roster.export.file.officialReady': 'Gata oficial',
  'roster.export.file.yes': 'da',
  'roster.export.file.no': 'nu',
  'roster.export.file.blocker': 'Motivul pentru care nu este gata oficial',
  'roster.export.column.shirt': 'Număr de tricou',
  'roster.export.column.familyName': 'Nume de familie',
  'roster.export.column.givenName': 'Prenume',
  'roster.export.column.role': 'Rol',
  'roster.export.column.outcome': 'Eligibilitate',
  'eligibility.title': 'Eligibilitate',
  'eligibility.hint':
    'Verifică fiecare sportiv din acest lot și lotul în ansamblu după versiunea de reguli activă a competiției și salvează rezultatul. Acoperă doar regulile automatizate; verificările manuale enumerate mai jos rămân în sarcina ta.',
  'eligibility.loading': 'Se încarcă verificarea eligibilității…',
  'eligibility.none': 'Acest lot nu a fost încă verificat.',
  'eligibility.evaluate': 'Verifică eligibilitatea',
  'eligibility.evaluate.again': 'Verifică din nou',
  'eligibility.evaluate.done': 'Eligibilitatea a fost verificată și salvată.',
  'eligibility.checked':
    'Verificat {checkedAt} pentru ziua meciului {matchDay}, cu versiunea de reguli {version}.',
  'eligibility.checkedWithoutRules':
    'Verificat {checkedAt} pentru ziua meciului {matchDay}, fără o versiune de reguli activă.',
  'eligibility.roster': 'Lotul în ansamblu:',
  'eligibility.outcome.ELIGIBLE': 'Eligibil',
  'eligibility.outcome.INELIGIBLE': 'Neeligibil',
  'eligibility.outcome.REVIEW_REQUIRED': 'Necesită verificare',
  'eligibility.stale': 'Ceva s-a schimbat de la această verificare. Verifică din nou.',
  'eligibility.decisionStale': 'depășit',
  'eligibility.removed': 'nu mai este în lot',
  'eligibility.rosterChanged': 'Lotul s-a schimbat de la această verificare. Verifică din nou.',
  'eligibility.rulesChanged': 'Acum este activă o altă versiune de reguli. Verifică din nou.',
  'eligibility.hidden': 'Au mai fost verificați {count} sportivi din afara ariei tale.',
  'eligibility.manualChecks': 'Verificări manuale care rămân în sarcina ta:',
  'eligibility.source': 'sursa',
  'eligibility.exception': 'rezolvat prin excepția {reference}',
  'eligibility.reason.unknown': 'Motiv {code}.',
  'eligibility.reason.PROFILE_MISSING':
    'Competiția nu are o versiune de reguli activă, deci este necesară verificarea.',
  'eligibility.reason.PROFILE_NOT_ACTIVE':
    'Versiunea de reguli este {status}, nu activă, deci este necesară verificarea.',
  'eligibility.reason.PROFILE_NOT_VALID_ON_DATE':
    'Versiunea de reguli activă nu acoperă ziua meciului.',
  'eligibility.reason.BIRTH_DATE_AFTER_MATCH': 'Data nașterii este după ziua meciului.',
  'eligibility.reason.REGISTRATION_MISSING': 'Sportivul nu este înregistrat în această competiție.',
  'eligibility.reason.REGISTRATION_NOT_VALID':
    'Înregistrarea în această competiție s-a încheiat sau nu acoperă ziua meciului.',
  'eligibility.reason.LICENSE_REFERENCE_MISSING': 'Înregistrarea nu are o referință de licență.',
  'eligibility.reason.CLASSIFICATION_NOT_PERMITTED':
    'Clasificarea „{classification}” nu este permisă în această competiție.',
  'eligibility.reason.AGE_BELOW_MINIMUM':
    'Vârsta de {age} ani în ziua meciului este sub vârsta minimă de {minimumAge} ani.',
  'eligibility.reason.EXCLUSIVE_HIGHER_REGISTRATION':
    'Sportivul este înregistrat exclusiv la categoria superioară {higherCategory}.',
  'eligibility.reason.BIRTH_DATE_ROUTE_NOT_DEFINED':
    'Regulile nu definesc un interval de naștere pentru această înregistrare, deci este necesară verificarea.',
  'eligibility.reason.AGE_EXCEPTION_NOT_SUPPORTED':
    'Regulile acestei competiții nu permit modul de înregistrare „{registrationMode}”.',
  'eligibility.reason.BIRTH_DATE_OUTSIDE_PERMITTED_RANGE':
    'Data nașterii este în afara intervalului permis pentru modul de înregistrare „{registrationMode}”.',
  'eligibility.reason.DOCUMENT_MISSING': 'Nu este înregistrat(ă): {documentType}.',
  'eligibility.reason.DOCUMENT_NOT_VERIFIED': 'Nu este verificat(ă): {documentType}.',
  'eligibility.reason.DOCUMENT_EXPIRED': 'A expirat înainte de ziua meciului: {documentType}.',
  'eligibility.reason.DOCUMENT_NOT_YET_VALID':
    'Nu este încă valabil(ă) în ziua meciului: {documentType}.',
  'eligibility.reason.SUSPENDED': 'O suspendare activă acoperă acest meci.',
  'eligibility.reason.ATTESTATION_MISSING': 'O aprobare necesară nu este înregistrată.',
  'eligibility.reason.ATTESTATION_DENIED': 'O aprobare necesară a fost refuzată.',
  'eligibility.reason.TEAM_CHANGE_OUTSIDE_WINDOW':
    'Mutarea între echipele clubului nu este permisă în această fază.',
  'eligibility.reason.EXTERNAL_HISTORY_INCOMPLETE':
    'Meciurile jucate în afara clubului nu sunt înregistrate, deci limitele de meciuri necesită verificare.',
  'eligibility.reason.DAILY_LIMIT_EXCEEDED':
    '{count} meciuri în ziua meciului; regulile {profileCategory} permit {maximum}.',
  'eligibility.reason.ROLLING_WINDOW_LIMIT_EXCEEDED':
    '{count} meciuri în {windowDays} zile; regulile {profileCategory} permit {maximum}.',
  'eligibility.reason.PLAYOFF_PARTICIPATION_UNCONFIRMED':
    'Participarea în playoff contează doar după ce un administrator al clubului confirmă ce se numără.',
  'eligibility.reason.PLAYOFF_PARTICIPATION_UNKNOWN':
    'Participarea în playoff nu este înregistrată.',
  'eligibility.reason.PLAYOFF_PARTICIPATION_BELOW_MINIMUM':
    '{appearances} prezențe în {matches} meciuri înseamnă sub {minimumPercent}%.',
  'eligibility.reason.ROSTER_RULES_NOT_DEFINED':
    'Regulile nu definesc dimensiunea lotului pentru această echipă.',
  'eligibility.reason.ROSTER_SKATERS_MINIMUM_DEPENDS_ON_REVIEW':
    'Minimul de {minimum} jucători de câmp este atins doar dacă sportivii în verificare sunt confirmați.',
  'eligibility.reason.ROSTER_SKATERS_MINIMUM_NEEDS_PROMOTED_COUNT_REVIEW':
    'Minimul de {minimum} jucători de câmp este atins doar socotind sportivii promovați.',
  'eligibility.reason.ROSTER_SKATERS_BELOW_MINIMUM':
    '{counted} jucători de câmp eligibili; sunt necesari cel puțin {minimum}.',
  'eligibility.reason.ROSTER_SKATERS_ABOVE_MAXIMUM':
    '{counted} jucători de câmp; sunt permiși cel mult {maximum}.',
  'eligibility.reason.ROSTER_GOALKEEPERS_MINIMUM_DEPENDS_ON_REVIEW':
    'Minimul de {minimum} portari este atins doar dacă sportivii în verificare sunt confirmați.',
  'eligibility.reason.ROSTER_GOALKEEPERS_MINIMUM_NEEDS_PROMOTED_COUNT_REVIEW':
    'Minimul de {minimum} portari este atins doar socotind sportivii promovați.',
  'eligibility.reason.ROSTER_GOALKEEPERS_BELOW_MINIMUM':
    '{counted} portari eligibili; sunt necesari cel puțin {minimum}.',
  'eligibility.reason.ROSTER_GOALKEEPERS_ABOVE_MAXIMUM':
    '{counted} portari; sunt permiși cel mult {maximum}.',
  'eligibility.reason.ROSTER_PROMOTION_QUOTA_EXCEEDED':
    '{counted} sportivi promovați temporar; sunt permiși cel mult {maximum}.',
  'eligibility.reason.ROSTER_HAS_INELIGIBLE_ENTRIES': '{count} sportivi nu sunt eligibili.',
  'eligibility.reason.ROSTER_HAS_ENTRIES_UNDER_REVIEW': '{count} sportivi necesită verificare.',
  'error.roster.athleteNotActive': 'Doar un sportiv activ poate fi selectat într-un lot.',
  'error.roster.shirtNumberTaken': 'Un alt sportiv din acest lot poartă deja acest număr.',
  'error.roster.finalized': 'Acest lot este finalizat. Redeschide-l ca să îl modifici.',
  'error.roster.empty': 'Selectează cel puțin un sportiv înainte de a finaliza lotul.',
  'error.roster.notFinalizable':
    'Lotul nu poate fi finalizat: un sportiv nu este eligibil sau lotul încalcă o regulă. Verifică eligibilitatea ca să vezi motivul.',
  'error.roster.acknowledgementRequired':
    'Ceva din acest lot mai necesită verificare. Declară în cuvinte că ai verificat, apoi finalizează.',
  'error.roster.notFinalized': 'Acest lot nu este finalizat.',
} as const satisfies Record<TranslationKey, string>;
